var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-90",
    cx: 250.05,
    cy: 342.43,
    rx: 236.13,
    ry: 130.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-90",
    cx: 361.15,
    cy: 387.49,
    rx: 72.37,
    ry: 41.78,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-90",
    cx: 131.06,
    cy: 387.49,
    rx: 72.37,
    ry: 41.78,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-90",
    d: "M90,327.15,240.4,414a4.68,4.68,0,0,0,4.19,0L413,316.82a1.28,1.28,0,0,0,0-2.42L262.54,227.52a4.66,4.66,0,0,0-4.18,0L90,324.73A1.28,1.28,0,0,0,90,327.15Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.58,265.14a1.21,1.21,0,0,0,1.21-1.21v-77.4a1.21,1.21,0,1,0-2.41,0v77.4A1.21,1.21,0,0,0,343.58,265.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.69,237a1.21,1.21,0,0,0,1.12-.76l23.74-60.08a1.2,1.2,0,1,0-2.24-.88l-23.74,60.08a1.21,1.21,0,0,0,.68,1.56A1.32,1.32,0,0,0,295.69,237Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.54,229.75a1.22,1.22,0,0,0,.88-.38l44.16-46.74,44.09,46.54a1.19,1.19,0,0,0,1.7.05,1.21,1.21,0,0,0,.05-1.7l-45-47.47a1.22,1.22,0,0,0-.88-.37h0a1.18,1.18,0,0,0-.87.37l-45,47.67a1.21,1.21,0,0,0,.87,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.47,237a1.32,1.32,0,0,0,.44-.08,1.2,1.2,0,0,0,.68-1.56l-23.73-60.08a1.2,1.2,0,1,0-2.24.88l23.73,60.08A1.21,1.21,0,0,0,391.47,237Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.33,227.89l-3.14,8.28a.76.76,0,0,0,0,.21v.15a1,1,0,0,0,.47.53,2.14,2.14,0,0,0,1.91,0,.88.88,0,0,0,.38-.39v0l0-.11,2.91-7.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.84,227.89l3.13,8.28a.76.76,0,0,1,0,.21.38.38,0,0,1,0,.15,1,1,0,0,1-.47.53,2.14,2.14,0,0,1-1.91,0,.85.85,0,0,1-.37-.39v0l0-.11-2.91-7.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.19,257.94v6.85a.71.71,0,0,0,.41.57,2.18,2.18,0,0,0,2,0,.71.71,0,0,0,.41-.57v-6.85A2.92,2.92,0,0,0,342.19,257.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,167.45c0-2.15,1.89-4.45,5.89-7,7.38-4.79,28.86-16.78,39.18-22.5a.12.12,0,0,1,.09-.09c7.95-4.82,10.36-25.4,15.86-42.85,1.87-6,4.17-9.31,6.89-10.89.65-.38,3-1.69,3.56-2,5.4-3.23,12.48.65,21.3,5.48C390.65,92,397,97.69,398.27,112.8c.78,9.2,0,26.77-1.83,40.1v0c-2.71,22.26-6,22.3-10.85,26-8.3,6.41-27,15.42-34.85,18.52-14.29,5.62-26-3-34.66-7.34a202.43,202.43,0,0,1-23-13.66c-2.18-1.58-3.31-3.18-3.28-4.86C289.77,170.89,289.75,168.15,289.75,167.45Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.75,167.45c0-2.15,1.89-4.45,5.89-7,7.38-4.79,28.86-16.78,39.18-22.5a.12.12,0,0,1,.09-.09c7.95-4.82,10.36-25.4,15.86-42.85,1.87-6,4.17-9.31,6.89-10.89.65-.38,3-1.69,3.56-2,5.4-3.23,12.48.65,21.3,5.48C390.65,92,397,97.69,398.27,112.8c.78,9.2,0,26.77-1.83,40.1v0c-2.71,22.26-6,22.3-10.85,26-8.3,6.41-27,15.42-34.85,18.52-14.29,5.62-26-3-34.66-7.34a202.43,202.43,0,0,1-23-13.66c-2.18-1.58-3.31-3.18-3.28-4.86C289.77,170.89,289.75,168.15,289.75,167.45Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.09,185.94a202.43,202.43,0,0,1-23-13.66c-5-3.59-4.5-7.27,2.6-11.87,9.85-6.4,44.85-25.64,44.85-25.64s50.79,30,48.61,35.51-28.45,19.1-38.35,23C336.46,198.9,324.79,190.24,316.09,185.94Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.09,185.94a202.43,202.43,0,0,1-23-13.66c-5-3.59-4.5-7.27,2.6-11.87,9.85-6.4,44.85-25.64,44.85-25.64s50.79,30,48.61,35.51-28.45,19.1-38.35,23C336.46,198.9,324.79,190.24,316.09,185.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M358,83.89c5.34-2.8,12.29,1,20.89,5.72,5.5,3,10.19,6.59,13,13.29l3.63-2.1c-2.85-6.67-7.53-10.24-13-13.25-8.82-4.83-15.9-8.71-21.3-5.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,83.89c5.34-2.8,12.29,1,20.89,5.72,5.5,3,10.19,6.59,13,13.29l3.63-2.1c-2.85-6.67-7.53-10.24-13-13.25-8.82-4.83-15.9-8.71-21.3-5.48Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.87,89.61c-13.2-7.22-22.52-12.36-28.1,5.36-5.5,17.45-7.91,38-15.86,42.85,0,0-2.42.21,17.34,15.14,6.29,4.75,13.92,8.64,18.93,11.63,9.82,5.85,15.77,8.2,16.72,7.42,5.19-4.31,8-42,6.72-57.15S387,94.06,378.87,89.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.26,
    y: 245.22,
    width: 9.45,
    height: 16.17,
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.68 249.77 286.23 250.09 285.76 232.98 295.2 232.65 295.68 249.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.13,247.18c-.49,0-.89.71-2,1.88-1.31,1.42-4.23,2.9-6.34,3.95-3.54,1.77-12.8,4.15-15.91,5.55-2,.88-1.46,3.9,1.3,5.6,2.05,1.26,8.6,2.49,14.43,1.18,3.17-.71,8-2.91,10.37-3.28,2.58-.41,7.35-.91,9.28-2.24s1.16-4.17.61-6.61c-.6-2.67-1.45-6.75-2.33-6.57l0,.84c-1.14,1.72-6.92,2.43-9.42,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.26,256.81c-.5,0-.9.71-2,1.88-1.31,1.42-4.23,2.9-6.34,3.95-3.54,1.77-12.8,4.15-15.91,5.55-1.95.88-1.46,3.9,1.3,5.6,2.05,1.26,8.6,2.49,14.43,1.18,3.17-.71,8-2.91,10.37-3.28,2.58-.41,7.35-.91,9.28-2.24s1.16-4.17.61-6.61c-.59-2.67-1.45-6.75-2.33-6.56l0,.83c-1.14,1.72-6.92,2.43-9.41,1.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,163.41c.54,11.38-.79,14.86-19.7,24.6-9.42,4.85-25.86,13.42-25.86,13.42s.73,3.66.83,14.12c.09,9.21-7.19,37.76-7.19,37.76s-7.69,4-10.78,0c0,0-.11-21.05,0-32.72.17-18.56-.8-23.59,0-27,.57-2.4,19.14-18.69,19.14-18.69l5-3.15-30.93,19.66s-.63,9-1.52,14.63C301,219.24,295.68,241,295.68,241s-6.88,3.08-10.29.42c0,0-.71-53.33-.71-57.81,0-6.81,10.94-14.47,35.95-29.25,5.33-3.15,12.45-6.63,12.45-6.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,171.77S331,169.52,327,161a21.65,21.65,0,0,0,2.77,8.75c1.8,2.82-25.16,21.69-25.16,21.69Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.86,99c-2.54,5.38-11.49,28.05-11.49,28.05l7.27,12.33c2.72-2.26,10.22-20.77,11.14-22.2,2.47-3.84,6.86-28.52,6.86-28.52C331.4,89,329.44,93.52,326.86,99Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.23,89.87a14.47,14.47,0,0,0-5.45-1.51c-8-1-12.72,1.53-15.55,6.08-3.77,6.07-11.3,26.42-11.3,26.42s4.57,7,13.21,8l13.38-23.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349.23,89.87a14.47,14.47,0,0,0-5.45-1.51c-8-1-12.72,1.53-15.55,6.08-3.77,6.07-11.3,26.42-11.3,26.42s4.57,7,13.21,8l13.38-23.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M358.54,88.8c1.11.27,10.32,2.42,14.38,3.8v31.11l1.22,39.7c-6.7,7.29-42,2.69-46.13-12.8,0,0,.22-37.76.22-45.2s4.14-16.38,15.55-17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,52.19a4.9,4.9,0,0,0-2.63-1.41l3.43-1.85a2.76,2.76,0,0,0-3.8-1.25,3,3,0,0,0-1.28,3.79l-1.2,13.33-1.13-.11-.47,7.75-.13,6.45c3.11-.08,5.43-3.13,7.21-13.55C367.4,57.47,367.77,54,366,52.19Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,52.19a4.9,4.9,0,0,0-2.63-1.41l3.43-1.85a2.76,2.76,0,0,0-3.8-1.25,3,3,0,0,0-1.28,3.79l-1.2,13.33-1.13-.11-.47,7.75-.13,6.45c3.11-.08,5.43-3.13,7.21-13.55C367.4,57.47,367.77,54,366,52.19Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.65,47.72c-1.71-1-2.16,1-1.22,2.66a8,8,0,0,0,6.49,4.32c.05-.24,1.6-4.36,1.6-4.36l-3.37-1.9A8.69,8.69,0,0,1,325.65,47.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.65,47.72c-1.71-1-2.16,1-1.22,2.66a8,8,0,0,0,6.49,4.32c.05-.24,1.6-4.36,1.6-4.36l-3.37-1.9A8.69,8.69,0,0,1,325.65,47.72Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.13,66c.83.5,2-1.1,3-2.17s4.36-2.53,6,1-1.47,8.31-4.1,9.14c-4.54,1.42-5.22-1.49-5.22-1.49l-.34,16.36s-3,7.26-11,8.35-6.39-5.54-3.75-8.79l0-5a28.71,28.71,0,0,1-6.12.31c-3.33-.52-5.43-3.15-6.44-6.76-1.62-5.79-2.24-10.47-.86-21.88,1.51-12.49,16-12.62,23.89-7.68S359.13,66,359.13,66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.13,67.38c.42,0,2-2.63,3-3.57,1.43-1.3-.42-13.1-.42-13.1s1.45-4.47-1.38-7.44-8.31-2.47-12.32-2.61a36,36,0,0,1-14.34-2.88c-5.69-2.47-6.12-2.76-6.82-.26s-1,8.22,2.42,12.06l2.83,1s1.53,1.36,6.84,2,13.58-.12,14.71-.28c1.54-.21,1.87,1.29,2.7,5.36C357.12,61.28,357.73,67.35,359.13,67.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.13,67.38c.42,0,2-2.63,3-3.57,1.43-1.3-.42-13.1-.42-13.1s1.45-4.47-1.38-7.44-8.31-2.47-12.32-2.61a36,36,0,0,1-14.34-2.88c-5.69-2.47-6.12-2.76-6.82-.26s-1,8.22,2.42,12.06l2.83,1s1.53,1.36,6.84,2,13.58-.12,14.71-.28c1.54-.21,1.87,1.29,2.7,5.36C357.12,61.28,357.73,67.35,359.13,67.38Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.8,83.39s7.44-1.5,10-2.89a8.55,8.55,0,0,0,3.6-3.56,11.81,11.81,0,0,1-2,4.2c-1.91,2.43-11.6,4.23-11.6,4.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.67,64.05a1.49,1.49,0,1,0,1.49-1.55A1.52,1.52,0,0,0,342.67,64.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,58.42l3.19,1.76a1.91,1.91,0,0,0-.74-2.54A1.78,1.78,0,0,0,344.25,58.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,74.35l-3.41,1.28a1.79,1.79,0,0,0,2.32,1.13A1.91,1.91,0,0,0,342.47,74.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.69,59.66l2.91-2.24a1.76,1.76,0,0,0-2.53-.39A1.94,1.94,0,0,0,330.69,59.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,63.14a1.49,1.49,0,1,0,1.49-1.55A1.52,1.52,0,0,0,331,63.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.36 62.21 337.87 71.18 333.19 69.58 338.36 62.21",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.55,91.93s5.94,1,8.67,6.42c1.64,3.23,7,11.65,10.34,17.32l3.1,5.31S412,110.2,413.13,108.79s1.07-4.27,1.24-5.81c.29-2.57-.65-4.79-.79-5.71-.28-2,2.56-1.52,3.46-.74a8.51,8.51,0,0,1,1.46,2.12c.44.74,1.27,3.13,2.11,3.28.66.12,2-.82,2.51-1.23,2.24-1.68,3.62-4,5.33-6.16a3.15,3.15,0,0,1,1.23-1.07,3,3,0,0,1,2.5.66A5.73,5.73,0,0,1,434,95.76a5.19,5.19,0,0,1,.62,1.63c.89,3.89-1.08,7.18-3.44,10.12a35.42,35.42,0,0,1-8.32,7.36c-1.85,1.21-4.3,2.28-6.39,3.42S390.23,140,387,137.87c-1.3-.89-5.3-5.88-9.17-10.59a71,71,0,0,1-6.95-10C362.13,109.49,369.55,91.93,369.55,91.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,114.92c-4.75-9.34-2.48-20.31.89-23.48,8.57,1.47,9.63,5.87,14,13.54,6.32,11.14,8.78,14.51,8.78,14.51-2.14,2.86-8.33,10.16-12.51,10.39Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M368.14,114.92c-4.75-9.34-2.48-20.31.89-23.48,8.57,1.47,9.63,5.87,14,13.54,6.32,11.14,8.78,14.51,8.78,14.51-2.14,2.86-8.33,10.16-12.51,10.39Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Girl--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.37,265.6a1.21,1.21,0,0,1-1.2-1.21V187a1.21,1.21,0,0,1,2.41,0v77.4A1.21,1.21,0,0,1,178.37,265.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27,237.42a1.19,1.19,0,0,1-1.12-.76l-23.74-60.07a1.21,1.21,0,1,1,2.24-.89l23.73,60.08a1.19,1.19,0,0,1-.67,1.56A1.17,1.17,0,0,1,226.27,237.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41,230.21a1.2,1.2,0,0,1-.87-.38l-44.17-46.74-44.08,46.54a1.2,1.2,0,0,1-1.75-1.65l45-47.47a1.19,1.19,0,0,1,.87-.37h0a1.17,1.17,0,0,1,.87.38l45,47.66a1.21,1.21,0,0,1-.88,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,237.42a1.17,1.17,0,0,1-.44-.08,1.2,1.2,0,0,1-.68-1.56L153.1,175.7a1.21,1.21,0,1,1,2.24.89L131.6,236.66A1.19,1.19,0,0,1,130.48,237.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,228.35l3.14,8.28a.78.78,0,0,1,0,.22V237a1.05,1.05,0,0,1-.48.52,2.14,2.14,0,0,1-1.91,0,.9.9,0,0,1-.37-.39v0l0-.11-2.91-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12,228.35,129,236.63a.78.78,0,0,0,0,.22V237a1.05,1.05,0,0,0,.48.52,2.14,2.14,0,0,0,1.91,0,.9.9,0,0,0,.37-.39v0l0-.11,2.91-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,258.4v6.85a.69.69,0,0,1-.4.57,2.2,2.2,0,0,1-2,0,.69.69,0,0,1-.4-.57V258.4A3,3,0,0,1,179.76,258.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2,175.77c0-2.15-1.89-4.45-5.88-7-7.38-4.79-28.86-16.78-39.19-22.5a.11.11,0,0,0-.08-.09c-8-4.82-10.36-25.4-15.86-42.85-1.88-6-4.17-9.31-6.9-10.9-.64-.37-3-1.68-3.55-2-5.4-3.23-12.48.65-21.3,5.48-8.13,4.45-14.48,10.14-15.76,25.25-.77,9.2,0,26.77,1.84,40.1v0c2.71,22.26,6,22.3,10.85,26,8.29,6.41,27,15.42,34.85,18.52,14.28,5.62,26-3,34.65-7.34a202.74,202.74,0,0,0,23.06-13.66c2.18-1.58,3.3-3.18,3.28-4.86C232.19,179.21,232.21,176.47,232.2,175.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.86,194.26a202.74,202.74,0,0,0,23.06-13.66c5-3.59,4.49-7.27-2.6-11.87-9.86-6.4-44.86-25.64-44.86-25.64s-50.79,30-48.6,35.51,28.45,19.1,38.35,23C185.49,207.22,197.17,198.55,205.86,194.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,92.21c-5.35-2.8-12.3,1-20.89,5.72-5.5,3-10.2,6.59-13.05,13.28l-3.62-2.09c2.85-6.67,7.53-10.24,13-13.25,8.82-4.83,15.9-8.71,21.3-5.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,97.93c13.2-7.22,22.51-12.36,28.1,5.36,5.5,17.45,7.91,38,15.86,42.85,0,0,2.42.21-17.34,15.14-6.29,4.75-13.92,8.64-18.93,11.63-9.82,5.85-15.78,8.2-16.72,7.42-5.19-4.31-8-42-6.72-57.15S135,102.38,143.09,97.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.63,222.15c-.78.67-1.68,1.45-1.68,2.39a9.46,9.46,0,0,0,2,5.55c1.73,2.32,2.6,6.48,2.68,9.26s-.38,9.79,2.81,12.89,11.47,5.35,12,.25-7.53-25.71-7.53-25.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,225.91a75,75,0,0,1,2.28,11.29c.44,4.17,1.35,7.18,3.32,8.49s5.11,1.44,4.22-1.46-3.89-17.45-3.89-17.45Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,148.65s18.76,7.09,26.37,12.23,11.57,8.73,12.81,12.38c1.32,3.86.56,9.11-4.07,22.79-1,3-6.85,21.88-6.85,21.88l-13.64-32L174,168.88Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,148.65s18.76,7.09,26.37,12.23,11.57,8.73,12.81,12.38c1.32,3.86.56,9.11-4.07,22.79-1,3-6.85,21.88-6.85,21.88l-13.64-32L174,168.88Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,252.74c-.73.38-.81,2.07-.87,3.31s-1.12,2.78.48,4.87,4.61,2.57,6.79,5.42,3.57,6.92,10.27,8,11.62-1.42,12.75-3.46-.09-3.85-4.46-6c-4.63-2.32-6-3-6-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,238.73s3.7,8.67,5.87,12.62,3.57,6.5,7.18,9.9c.79.74,2.54,2.09,3.18,2.69a1.27,1.27,0,0,1,.07,2c-1.3,1.52-7.34,2.46-11,.26s-5.64-5.6-7.89-7.45c-1.12-.92-2.17-1.81-2.95-2.46a2.77,2.77,0,0,1-1-2.56c0-.27.09-.59.14-1,.27-2-3.15-9.81-3.15-9.81Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36,152.23c-2.64,7.68-3.07,17.53,3.95,24,4.67,4.29,15,11.08,23.1,14.81s20.41,9.9,22.81,10.68,2.77,2.15,2.9,6.55,2.36,11.41,8.13,19.88c6.1,8.94,9.63,14.8,9.63,14.8a10.2,10.2,0,0,0,10-3.54s-11.22-46.54-13.75-52.06S178,166.13,178,166.13a178,178,0,0,0,4.14-17.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.36,152.23c-2.64,7.68-3.07,17.53,3.95,24,4.67,4.29,15,11.08,23.1,14.81s20.41,9.9,22.81,10.68,2.77,2.15,2.9,6.55,2.36,11.41,8.13,19.88c6.1,8.94,9.63,14.8,9.63,14.8a10.2,10.2,0,0,0,10-3.54s-11.22-46.54-13.75-52.06S178,166.13,178,166.13a178,178,0,0,0,4.14-17.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.05,190.08c-1.78-5.66-6.49-9.77-10.94-13.21-3.65-2.8-13-9.57-16.19-11.92a36,36,0,0,0,1.49-6.47s-2.18,5.21-3.43,7.65h0s22.7,15.86,25.15,21.2c1.41,3.07,5.05,19.73,8.8,32C211.54,217.45,208.73,195.46,207.05,190.08Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,135.21S96.28,131,94.73,130s-2.37-3.82-3-5.26c-1.08-2.42-.85-4.86-1-5.81-.33-2-2.95-.68-3.59.36a8.91,8.91,0,0,0-.76,2.51c-.2.86-.26,3.44-1,3.86-.6.32-2.17-.19-2.82-.42-2.7-1-4.77-2.8-7.1-4.35a3.11,3.11,0,0,0-1.53-.65,3,3,0,0,0-2.23,1.41,5.87,5.87,0,0,0-1.26,2.15,5.08,5.08,0,0,0-.1,1.78c.34,4.06,3.28,6.65,6.49,8.78A36.07,36.07,0,0,0,87.14,139c2.18.6,4.89.89,7.28,1.35s31,12,34,9.49c1.86-1.57,3.73-7.94,5.72-13.83A169.89,169.89,0,0,0,139,117.37a30.25,30.25,0,0,0-5-18.17s-5.47,1.11-7.6,9.22c-.93,3.57-4.16,14.11-5.63,20.67-.81,3.56-1.38,6.12-1.38,6.12",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,114.79c3-7,1.11-18.59-2.27-21.76-8.57,1.47-10.73,5.51-13.09,13.49-3.63,12.28-5.46,20.25-5.46,20.25,2.14,2.85,11.88,6.42,15.89,5.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14,91.38a13.4,13.4,0,0,1,7.38-2.15c3.86.25,8.27,1.61,11.09,6.15,3.78,6.07,12.57,19.41,12.57,19.41a17.34,17.34,0,0,1-11.83,11.82l-13.51-19.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.54,122.19c.63,5.88,2.58,26.46,2.58,26.46-3.9,10-14.48,10.59-23,10.68-10.26.12-19.92-2.58-22.72-7.05a102.79,102.79,0,0,0,5.58-17.69l-3.76-16.44s9-8.19,0-24.94l11.9-3.56,14.18-1.16,8.26.74c4.66,3.41,7.75,10.35,9.24,14.17S186.31,114.23,179.54,122.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,141.42l.37-1.29c.92-3.32,1.37-5.54,1.37-5.54l-3.76-16.44h0l0,0,0,0,.38-.41h0c1.19-1.38,4.26-5.73,3.38-13.13h0s2.59,9.46-.77,14.38l3.18,14.25,4.59,6.68-5.57-2.19s-2,7.86-2.2,10.45c-.13,2,4.6,8.64,14.73,11.18-9.05-.4-17.1-3-19.61-7h0A97.08,97.08,0,0,0,140.2,141.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.14,37.19h0a23.58,23.58,0,0,1,23.58,23.58V86.13a0,0,0,0,1,0,0H152.83a18.27,18.27,0,0,1-18.27-18.27v-7.1A23.58,23.58,0,0,1,158.14,37.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,66.82c20.76.22,22.58-19.46,22.58-19.46A76.82,76.82,0,0,1,149.77,66.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47,44.45a3,3,0,0,0-3.9-1.94l1.37,4.5a3.15,3.15,0,0,0-1.49-1.11,3,3,0,0,0-3.87,2L138.44,50a3.35,3.35,0,0,0,.08-1.57A3.26,3.26,0,0,0,140.47,44.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.35,47.36c2.53,1.4,5.78,7.58,5.84,20.72,0,11.14-3.49,14-5.28,14.83s-5.3.46-8.71,0l.06,5.6s6.13,5.71,5.91,8.78-7.83,4.67-12.3,1.79-8.35-8.52-8.35-8.52l-.33-15.44s-1.94,2-5.41-.87c-2.87-2.37-3.92-6.47-1.8-8.75a4.87,4.87,0,0,1,7.79,1.34s5.43.05,12.53-4.11A20.25,20.25,0,0,0,172.35,47.36Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.09,65a1.4,1.4,0,1,1-1.51-1.34A1.44,1.44,0,0,1,167.09,65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,75.05l3.27,1a1.67,1.67,0,0,1-2.08,1.22A1.78,1.78,0,0,1,166.32,75.05Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,60.35l-2.88-1.89a1.66,1.66,0,0,1,2.34-.54A1.81,1.81,0,0,1,177,60.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,63.57a1.41,1.41,0,0,1-1.28,1.55,1.46,1.46,0,1,1,1.28-1.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.69 63.41 170.85 72.53 175.25 71.04 170.69 63.41",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,82.89c-3.59-.37-11-2.29-12.24-5.17a7.54,7.54,0,0,0,2.68,3.65c2.26,1.82,9.59,3.75,9.59,3.75Z",
    style: {
      fill: "#9a4a4d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.46,397.42a1.14,1.14,0,0,0,.68,1,3.75,3.75,0,0,0,3.39,0,1.21,1.21,0,0,0,.71-1h0l.06-97.53-4.78.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.09,398.81a3.39,3.39,0,0,0,1.44-.4,1.21,1.21,0,0,0,.71-1h0l.06-97.53-2.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.21,300.92a3.73,3.73,0,0,0,3.38,0c.94-.55,1-1.42,0-2a3.78,3.78,0,0,0-3.39,0C254.29,299.51,254.28,300.39,255.21,300.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.38,317.42a1.14,1.14,0,0,0,.68,1,3.7,3.7,0,0,0,3.38,0,1.17,1.17,0,0,0,.71-1h0l.06-97.53-4.78.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,318.81a3.17,3.17,0,0,0,1.43-.4,1.17,1.17,0,0,0,.71-1h0l.06-97.53-2.15,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,220.92a3.75,3.75,0,0,0,3.39,0c.94-.55.95-1.42,0-2a3.76,3.76,0,0,0-3.38,0C392.21,219.51,392.2,220.39,393.12,220.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.88,315.25a1.12,1.12,0,0,0,.68,1,3.75,3.75,0,0,0,3.39,0,1.23,1.23,0,0,0,.71-1h0l.06-97.52-4.78.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.51,316.63a3.38,3.38,0,0,0,1.44-.39,1.23,1.23,0,0,0,.71-1h0l.06-97.52-2.14,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,218.75a3.76,3.76,0,0,0,3.38,0c.94-.54.95-1.42,0-1.95a3.75,3.75,0,0,0-3.39,0C112.71,217.34,112.7,218.21,113.63,218.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.88,232.82V232a4.63,4.63,0,0,1,2.1-3.63l168.38-97.21a4.66,4.66,0,0,1,4.18,0L413,218a4.61,4.61,0,0,1,2.09,3.62v.84a4.61,4.61,0,0,1-2.09,3.62L244.59,323.32a4.62,4.62,0,0,1-4.19,0L90,236.45A4.63,4.63,0,0,1,87.88,232.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.88,232.82V232a4.63,4.63,0,0,1,2.1-3.63l168.38-97.21a4.66,4.66,0,0,1,4.18,0L413,218a4.61,4.61,0,0,1,2.09,3.62v.84a4.61,4.61,0,0,1-2.09,3.62L244.59,323.32a4.62,4.62,0,0,1-4.19,0L90,236.45A4.63,4.63,0,0,1,87.88,232.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,318.16v5.67a4.46,4.46,0,0,1-2.1-.5L90,236.45a4.6,4.6,0,0,1-2.09-3.62V232a4.62,4.62,0,0,1,1.7-3.35c-.75.64-.63,1.55.39,2.14L240.4,317.66A4.24,4.24,0,0,0,242.5,318.16Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.5,318.16v5.67a4.46,4.46,0,0,1-2.1-.5L90,236.45a4.6,4.6,0,0,1-2.09-3.62V232a4.62,4.62,0,0,1,1.7-3.35c-.75.64-.63,1.55.39,2.14L240.4,317.66A4.24,4.24,0,0,0,242.5,318.16Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90,230.78,240.4,317.65a4.62,4.62,0,0,0,4.19,0L413,220.44a1.27,1.27,0,0,0,0-2.41L262.54,131.15a4.66,4.66,0,0,0-4.18,0L90,228.36A1.28,1.28,0,0,0,90,230.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90,230.78,240.4,317.65a4.62,4.62,0,0,0,4.19,0L413,220.44a1.27,1.27,0,0,0,0-2.41L262.54,131.15a4.66,4.66,0,0,0-4.18,0L90,228.36A1.28,1.28,0,0,0,90,230.78Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,264.21a4.21,4.21,0,0,1-2.08-.52l-45.65-26.35a2.48,2.48,0,0,1,0-4.44l25.93-15a4.33,4.33,0,0,1,4.15,0l45.65,26.35a2.48,2.48,0,0,1,0,4.44l-25.93,15A4.17,4.17,0,0,1,207.37,264.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-laptop--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.67,245.3a2.56,2.56,0,0,1-1.19,2l-25.92,15a2.63,2.63,0,0,1-2.38,0l-45.65-26.36a2.23,2.23,0,0,1,0-3.95l25.92-15a2.63,2.63,0,0,1,2.38,0l45.65,26.35A2.56,2.56,0,0,1,235.67,245.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.37,260v2.57a2.43,2.43,0,0,0,1.19-.28l25.92-15a2.23,2.23,0,0,0,.12-3.88c.54.38.5.94-.12,1.3l-25.92,15A2.44,2.44,0,0,1,207.37,260Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,243.37c.62-.36.58-1,.58-1.72V205.84a2.62,2.62,0,0,0-1.19-2.06l-45.65-26.35a2.56,2.56,0,0,0-2.3-.05c-.62.36-.59,1-.59,1.72v35.81a2.65,2.65,0,0,0,1.19,2.06l45.65,26.35A2.58,2.58,0,0,0,236.79,243.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,243.4a2.6,2.6,0,0,0,2.17,0c.62-.36.58-1,.58-1.72V205.84a2.36,2.36,0,0,0-.35-1.17l-1.7,1h0a2.36,2.36,0,0,1,.35,1.17v35.81C235.67,243.34,235.21,243.66,234.62,243.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.67,206.83v35.81c0,.76-.53,1.06-1.19.68L188.83,217a2.65,2.65,0,0,1-1.19-2.06V179.1c0-.76.54-1.07,1.19-.69l45.65,26.36A2.62,2.62,0,0,1,235.67,206.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.48,244.7l-25.92,15a2.63,2.63,0,0,1-2.38,0l-45.65-26.36a.72.72,0,0,1,0-1.37l25.92-15a2.63,2.63,0,0,1,2.38,0l45.65,26.35A.73.73,0,0,1,234.48,244.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84,206.14l-44-25.4c-.39-.23-.71,0-.71.41v33a1.57,1.57,0,0,0,.71,1.23l44,25.41c.4.22.72,0,.72-.42v-33A1.57,1.57,0,0,0,233.84,206.14Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84,206.14l-44-25.4c-.39-.23-.71,0-.71.41v33a1.57,1.57,0,0,0,.71,1.23l44,25.41c.4.22.72,0,.72-.42v-33A1.57,1.57,0,0,0,233.84,206.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,243.39l-42.37-24.46a1.33,1.33,0,0,0-1.2,0l-.7.39a.36.36,0,0,0,0,.69l42.38,24.46a1.31,1.31,0,0,0,1.19,0l.7-.39A.36.36,0,0,0,231.19,243.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.86,245.37l-42.37-24.46a1.21,1.21,0,0,0-1.09-.06l-11,6.37c-.28.15-.23.43.1.62l42.32,24.43a1.24,1.24,0,0,0,1.09.07L228,246C228.24,245.84,228.19,245.56,227.86,245.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34,231.19l1.27-.73s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,191.34,231.19Zm1.55-2.66-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.32-.77A.23.23,0,0,0,192.89,228.53Zm4.29,2.47-1.27.73s0,.08,0,.11l2.25,1.3a.21.21,0,0,0,.19,0l1.27-.74c.05,0,0-.07,0-.11L197.37,231A.19.19,0,0,0,197.18,231Zm-2.35-1.35-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,194.83,229.65Zm5.21,3-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.24.24,0,0,0,.2,0l1.27-.74c.05,0,0-.07,0-.11l-1.33-.76A.19.19,0,0,0,200,232.65Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.32-.76A.19.19,0,0,0,202,233.77Zm-4.59,3,1.26-.73s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77A.23.23,0,0,0,197.39,236.77Zm1.93,1.12,1.27-.73s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77A.21.21,0,0,0,199.32,237.89Zm1.94,1.12,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77A.21.21,0,0,0,201.26,239Zm1.94,1.12,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74s0,.08,0,.11l1.33.76A.19.19,0,0,0,203.2,240.13Zm-9.92-7.82,1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,193.28,232.31Zm2.17,3.34,1.27-.73c.05,0,0-.08,0-.11l-1.22-.71c-.06,0-.06-.08,0-.11l1.63-.94c.05,0,.05-.08,0-.11l-1.53-.89a.21.21,0,0,0-.19,0l-3.09,1.78c-.05,0,0,.08,0,.11l3,1.71A.23.23,0,0,0,195.45,235.65Zm8.46-.76-1.27.73s0,.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.26-.74c.05,0,.05-.08,0-.11l-1.32-.76A.21.21,0,0,0,203.91,234.89Zm1.94,1.12-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.25.25,0,0,0,.19,0l1.27-.74c.05,0,.05-.08,0-.11l-1.32-.76A.21.21,0,0,0,205.85,236ZM218,247.23c.05,0,.05-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.24.24,0,0,0,.2,0Zm3.32-2.27-1.26.74s0,.08,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.28.28,0,0,0,221.36,245Zm-1,1.52s0-.08,0-.11L219,245.6a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-6.43,1.94,1.27-.73s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77A.21.21,0,0,0,213.94,248.42Zm3.21.39s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm2.28-5-1.27.74s0,.08,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.25.25,0,0,0,219.43,243.84Zm-9.7-5.59-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,209.73,238.25Zm7.76,4.48-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,217.49,242.73Zm-9.7-5.6-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,207.79,237.13Zm3.88,2.24-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,211.67,239.37Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.21.21,0,0,0,213.61,240.49Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,215.55,241.61Zm-8.47.76,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,207.08,242.37Zm-18.47-16.32-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76A.21.21,0,0,0,188.61,226.05Zm2.34,1.36-1.27.73c-.05,0,0,.08,0,.11L191,229a.23.23,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.32-.77A.23.23,0,0,0,191,227.41Zm-4.28-2.48-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76A.21.21,0,0,0,186.67,224.93Zm11.1,10,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0-.05.08,0,.11l1.33.76A.19.19,0,0,0,197.77,234.9Zm-14.31-10.35c-.05,0-.05.07,0,.11l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0Zm21.68,16.7,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.08,0,.11l1.33.76A.19.19,0,0,0,205.14,241.25Zm-23.78-13.73,1.27-.73c.05,0,.05-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.21.21,0,0,0,181.36,227.52Zm3.76.08,1.27-.74c.05,0,0-.08,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.26.73c-.05,0-.05.08,0,.11l1.32.77A.28.28,0,0,0,185.12,227.6Zm-3.47-2c-.05,0-.05.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.32-.76a.19.19,0,0,0-.19,0Zm.85-1.08-1.33-.76a.19.19,0,0,0-.19,0l-3.09,1.78s0,.08,0,.11l1.32.77a.23.23,0,0,0,.2,0l3.08-1.78C182.56,224.59,182.55,224.54,182.5,224.51Zm4.29,2.59-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11L187,227.1A.23.23,0,0,0,186.79,227.1Zm14.6,8.42-1.27.74c-.05,0-.05.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.21.21,0,0,0,201.39,235.52Zm-16.82-7.61c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm14.88,6.49-1.27.74c-.05,0-.05.08,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.25.25,0,0,0,199.45,234.4Zm16.66,11.71s0-.07,0-.11l-1.32-.76a.24.24,0,0,0-.2,0l-1.26.73c-.05,0-.05.08,0,.12l1.32.76a.24.24,0,0,0,.2,0Zm.79-1.63-1.27.73s0,.08,0,.11l1.33.77a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.33-.76A.19.19,0,0,0,216.9,244.48Zm-4,1.25,1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.32.76A.24.24,0,0,0,212.9,245.73ZM211,244.61l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.21.21,0,0,0,211,244.61ZM209,243.49l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,209,243.49Zm5.94-.13-1.27.73c-.05,0-.05.08,0,.11L215,245a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.33-.76A.19.19,0,0,0,215,243.36ZM213,242.24l-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-1.33-.76A.19.19,0,0,0,213,242.24Zm-7.76-4.48-1.26.73c-.05,0-.05.08,0,.12l1.32.76a.24.24,0,0,0,.2,0l1.27-.73s0-.08,0-.12l-1.32-.76A.24.24,0,0,0,205.26,237.76Zm1.94,1.12-1.27.73c-.05,0,0,.08,0,.12l1.32.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.12l-1.32-.76A.24.24,0,0,0,207.2,238.88Zm-3.87-2.24-1.27.74c-.05,0-.05.07,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.21.21,0,0,0,203.33,236.64Zm7.75,4.48-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-1.33-.76A.19.19,0,0,0,211.08,241.12ZM209.14,240l-1.27.73c-.05,0,0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.74c.05,0,.05-.07,0-.11l-1.32-.76A.24.24,0,0,0,209.14,240Zm2.86,7.31,1.27-.74s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.25.25,0,0,0,212,247.31Zm10.05-.38,1.32.76a.2.2,0,0,0,.2,0l1.26-.73s0-.08,0-.11l-1.32-.77a.24.24,0,0,0-.2,0l-1.27.74C222,246.85,222,246.89,222.05,246.93Zm-2.53.63,2,1.18a.21.21,0,0,0,.19,0L223,248s0-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0l-1.27.73S219.46,247.53,219.52,247.56Zm4.42-2.08,1.63.94a.21.21,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.63-1a.21.21,0,0,0-.19,0l-1.27.73C223.88,245.4,223.88,245.45,223.94,245.48Zm0-1.57c.05,0,0-.08,0-.11l-1.32-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.24.24,0,0,0,.2,0Zm-6.76,4.4,2.56,1.48a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-2.55-1.47a.21.21,0,0,0-.2,0l-1.27.73C217.13,248.23,217.14,248.28,217.19,248.31Zm-.89,1.58,1.63.94a.21.21,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.63-.95a.21.21,0,0,0-.19,0l-1.27.73S216.24,249.86,216.3,249.89Zm-6.77-14.3c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm3.88,2.24c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm8.6,5c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-10.54-6.08c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm3.88,2.24c.05,0,0-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0-.05.08,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm-1.28,11.64s0,.08,0,.11l2,1.18a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0Zm4.06-10c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm1.94,1.11c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-41.92-11.82c-.05,0-.05.08,0,.11l3.26,1.89a.23.23,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-3.26-1.88a.19.19,0,0,0-.19,0Zm4.28,2.48c-.05,0,0,.08,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0Zm27.63,13.86,1.27-.74s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.25.25,0,0,0,210.06,246.19Zm-23.75-11.62c-.05,0-.05.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0Zm-10.1-5.84c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74c.05,0,0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0Zm-1.93-1,1.33.77a.21.21,0,0,0,.19,0l3.08-1.78c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-3.08,1.78C174.22,227.64,174.22,227.69,174.28,227.72Zm19.28,11c-.05,0-.05.08,0,.11l1.63.94a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.12L195,238a.23.23,0,0,0-.2,0Zm-4.9-2.83s0,.08,0,.11l2,1.18a.21.21,0,0,0,.19,0l1.27-.74c.05,0,.05-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0Zm9.39,5.42c-.05,0-.05.08,0,.11L209,247.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-10.92-6.31a.23.23,0,0,0-.2,0ZM209.58,248c-.05,0-.05.08,0,.11l1.63.94a.19.19,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.63-.95a.21.21,0,0,0-.19,0Zm-13.78-8c-.05,0,0,.08,0,.12l1.63.94a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.64-.94a.21.21,0,0,0-.19,0Zm16,9.25s0,.08,0,.12l1.64.94a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.64-.94a.21.21,0,0,0-.19,0Zm-20.51-11.84c-.05,0,0,.08,0,.11l1.63.95a.23.23,0,0,0,.2,0l1.27-.73c.05,0,0-.08,0-.11l-1.63-.94a.19.19,0,0,0-.19,0Zm-6.94-4c-.05,0,0,.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0Zm-2.88-3.76,1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,181.49,229.69Zm7.91.38,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,189.4,230.07Zm5.15,7.16,1.27-.73c.05,0,.05-.08,0-.11l-3.88-2.24a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l3.88,2.24A.19.19,0,0,0,194.55,237.23Zm-9.85-7.15c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm.54-.32,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0,0,.08,0,.11l1.33.76A.19.19,0,0,0,185.24,229.76Zm11.25,8.59,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,196.49,238.35Zm-7.51-5.8c.05,0,.05-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0ZM206.19,244l1.26-.74c.05,0,.05-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77A.24.24,0,0,0,206.19,244Zm-1.94-1.12,1.27-.74s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.32.76A.24.24,0,0,0,204.25,242.83Zm3.87,2.24,1.27-.74c.05,0,.05-.08,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77A.21.21,0,0,0,208.12,245.07Zm-7.75-4.48,1.27-.73c.05,0,0-.08,0-.12L200.3,239a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,200.37,240.59Zm1.94,1.12,1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,202.31,241.71Zm-3.88-2.24,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,198.43,239.47ZM188,223.69s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-.33.2s0,.07,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm10.57,5.57c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74s0,.08,0,.11l1.33.76a.19.19,0,0,0,.19,0ZM194.68,227c.06,0,0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.26.73s0,.08,0,.11l1.32.77a.23.23,0,0,0,.2,0Zm6.25,3.61s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-4.31-2.49s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0Zm8.19,4.72c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-1.94-1.12s0-.07,0-.11l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-11-5.81s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-.34.19c-.05,0,0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-5.81-3.36c.05,0,0-.07,0-.11l-1.32-.76a.24.24,0,0,0-.2,0l-.33.2c-.05,0-.05.08,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm-1.74,1c.05,0,.05-.08,0-.11L183,222.7a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76a.19.19,0,0,0,.19,0Zm-4.77,5,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,179.55,228.57Zm10.38-3.76s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-.34.2c-.05,0,0,.07,0,.11l1.32.76a.24.24,0,0,0,.2,0ZM206.75,234c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.34,231.19l1.27-.73s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,191.34,231.19Zm1.55-2.66-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.32-.77A.23.23,0,0,0,192.89,228.53Zm4.29,2.47-1.27.73s0,.08,0,.11l2.25,1.3a.21.21,0,0,0,.19,0l1.27-.74c.05,0,0-.07,0-.11L197.37,231A.19.19,0,0,0,197.18,231Zm-2.35-1.35-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,194.83,229.65Zm5.21,3-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.24.24,0,0,0,.2,0l1.27-.74c.05,0,0-.07,0-.11l-1.33-.76A.19.19,0,0,0,200,232.65Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.32-.76A.19.19,0,0,0,202,233.77Zm-4.59,3,1.26-.73s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77A.23.23,0,0,0,197.39,236.77Zm1.93,1.12,1.27-.73s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77A.21.21,0,0,0,199.32,237.89Zm1.94,1.12,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77A.21.21,0,0,0,201.26,239Zm1.94,1.12,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74s0,.08,0,.11l1.33.76A.19.19,0,0,0,203.2,240.13Zm-9.92-7.82,1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,193.28,232.31Zm2.17,3.34,1.27-.73c.05,0,0-.08,0-.11l-1.22-.71c-.06,0-.06-.08,0-.11l1.63-.94c.05,0,.05-.08,0-.11l-1.53-.89a.21.21,0,0,0-.19,0l-3.09,1.78c-.05,0,0,.08,0,.11l3,1.71A.23.23,0,0,0,195.45,235.65Zm8.46-.76-1.27.73s0,.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.26-.74c.05,0,.05-.08,0-.11l-1.32-.76A.21.21,0,0,0,203.91,234.89Zm1.94,1.12-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.25.25,0,0,0,.19,0l1.27-.74c.05,0,.05-.08,0-.11l-1.32-.76A.21.21,0,0,0,205.85,236ZM218,247.23c.05,0,.05-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.24.24,0,0,0,.2,0Zm3.32-2.27-1.26.74s0,.08,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.28.28,0,0,0,221.36,245Zm-1,1.52s0-.08,0-.11L219,245.6a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-6.43,1.94,1.27-.73s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77A.21.21,0,0,0,213.94,248.42Zm3.21.39s0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm2.28-5-1.27.74s0,.08,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.25.25,0,0,0,219.43,243.84Zm-9.7-5.59-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,209.73,238.25Zm7.76,4.48-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,217.49,242.73Zm-9.7-5.6-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,207.79,237.13Zm3.88,2.24-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77A.21.21,0,0,0,211.67,239.37Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.21.21,0,0,0,213.61,240.49Zm1.94,1.12-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.33-.77A.21.21,0,0,0,215.55,241.61Zm-8.47.76,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,207.08,242.37Zm-18.47-16.32-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76A.21.21,0,0,0,188.61,226.05Zm2.34,1.36-1.27.73c-.05,0,0,.08,0,.11L191,229a.23.23,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.32-.77A.23.23,0,0,0,191,227.41Zm-4.28-2.48-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76A.21.21,0,0,0,186.67,224.93Zm11.1,10,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0-.05.08,0,.11l1.33.76A.19.19,0,0,0,197.77,234.9Zm-14.31-10.35c-.05,0-.05.07,0,.11l1.33.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0Zm21.68,16.7,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.08,0,.11l1.33.76A.19.19,0,0,0,205.14,241.25Zm-23.78-13.73,1.27-.73c.05,0,.05-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.21.21,0,0,0,181.36,227.52Zm3.76.08,1.27-.74c.05,0,0-.08,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.26.73c-.05,0-.05.08,0,.11l1.32.77A.28.28,0,0,0,185.12,227.6Zm-3.47-2c-.05,0-.05.08,0,.11l1.32.77a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.32-.76a.19.19,0,0,0-.19,0Zm.85-1.08-1.33-.76a.19.19,0,0,0-.19,0l-3.09,1.78s0,.08,0,.11l1.32.77a.23.23,0,0,0,.2,0l3.08-1.78C182.56,224.59,182.55,224.54,182.5,224.51Zm4.29,2.59-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11L187,227.1A.23.23,0,0,0,186.79,227.1Zm14.6,8.42-1.27.74c-.05,0-.05.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.21.21,0,0,0,201.39,235.52Zm-16.82-7.61c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm14.88,6.49-1.27.74c-.05,0-.05.08,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77A.25.25,0,0,0,199.45,234.4Zm16.66,11.71s0-.07,0-.11l-1.32-.76a.24.24,0,0,0-.2,0l-1.26.73c-.05,0-.05.08,0,.12l1.32.76a.24.24,0,0,0,.2,0Zm.79-1.63-1.27.73s0,.08,0,.11l1.33.77a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.33-.76A.19.19,0,0,0,216.9,244.48Zm-4,1.25,1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.32.76A.24.24,0,0,0,212.9,245.73ZM211,244.61l1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.21.21,0,0,0,211,244.61ZM209,243.49l1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,209,243.49Zm5.94-.13-1.27.73c-.05,0-.05.08,0,.11L215,245a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.33-.76A.19.19,0,0,0,215,243.36ZM213,242.24l-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-1.33-.76A.19.19,0,0,0,213,242.24Zm-7.76-4.48-1.26.73c-.05,0-.05.08,0,.12l1.32.76a.24.24,0,0,0,.2,0l1.27-.73s0-.08,0-.12l-1.32-.76A.24.24,0,0,0,205.26,237.76Zm1.94,1.12-1.27.73c-.05,0,0,.08,0,.12l1.32.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.12l-1.32-.76A.24.24,0,0,0,207.2,238.88Zm-3.87-2.24-1.27.74c-.05,0-.05.07,0,.11l1.32.76a.21.21,0,0,0,.2,0l1.27-.73s0-.08,0-.11l-1.32-.77A.21.21,0,0,0,203.33,236.64Zm7.75,4.48-1.27.73c-.05,0,0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-1.33-.76A.19.19,0,0,0,211.08,241.12ZM209.14,240l-1.27.73c-.05,0,0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0l1.27-.74c.05,0,.05-.07,0-.11l-1.32-.76A.24.24,0,0,0,209.14,240Zm2.86,7.31,1.27-.74s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.25.25,0,0,0,212,247.31Zm10.05-.38,1.32.76a.2.2,0,0,0,.2,0l1.26-.73s0-.08,0-.11l-1.32-.77a.24.24,0,0,0-.2,0l-1.27.74C222,246.85,222,246.89,222.05,246.93Zm-2.53.63,2,1.18a.21.21,0,0,0,.19,0L223,248s0-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0l-1.27.73S219.46,247.53,219.52,247.56Zm4.42-2.08,1.63.94a.21.21,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.63-1a.21.21,0,0,0-.19,0l-1.27.73C223.88,245.4,223.88,245.45,223.94,245.48Zm0-1.57c.05,0,0-.08,0-.11l-1.32-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.32.77a.24.24,0,0,0,.2,0Zm-6.76,4.4,2.56,1.48a.21.21,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-2.55-1.47a.21.21,0,0,0-.2,0l-1.27.73C217.13,248.23,217.14,248.28,217.19,248.31Zm-.89,1.58,1.63.94a.21.21,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-1.63-.95a.21.21,0,0,0-.19,0l-1.27.73S216.24,249.86,216.3,249.89Zm-6.77-14.3c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm3.88,2.24c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm8.6,5c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-10.54-6.08c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm3.88,2.24c.05,0,0-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0-.05.08,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm-1.28,11.64s0,.08,0,.11l2,1.18a.21.21,0,0,0,.19,0l1.27-.74s0-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0Zm4.06-10c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm1.94,1.11c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-41.92-11.82c-.05,0-.05.08,0,.11l3.26,1.89a.23.23,0,0,0,.2,0l1.26-.73c.05,0,.05-.08,0-.11l-3.26-1.88a.19.19,0,0,0-.19,0Zm4.28,2.48c-.05,0,0,.08,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0Zm27.63,13.86,1.27-.74s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l1.33.77A.25.25,0,0,0,210.06,246.19Zm-23.75-11.62c-.05,0-.05.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0Zm-10.1-5.84c-.05,0-.05.08,0,.11l1.33.77a.21.21,0,0,0,.19,0l1.27-.74c.05,0,0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0Zm-1.93-1,1.33.77a.21.21,0,0,0,.19,0l3.08-1.78c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-3.08,1.78C174.22,227.64,174.22,227.69,174.28,227.72Zm19.28,11c-.05,0-.05.08,0,.11l1.63.94a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.12L195,238a.23.23,0,0,0-.2,0Zm-4.9-2.83s0,.08,0,.11l2,1.18a.21.21,0,0,0,.19,0l1.27-.74c.05,0,.05-.07,0-.11l-2-1.18a.21.21,0,0,0-.19,0Zm9.39,5.42c-.05,0-.05.08,0,.11L209,247.76a.21.21,0,0,0,.19,0l1.27-.73c.05,0,0-.08,0-.11l-10.92-6.31a.23.23,0,0,0-.2,0ZM209.58,248c-.05,0-.05.08,0,.11l1.63.94a.19.19,0,0,0,.19,0l1.27-.73s0-.08,0-.11l-1.63-.95a.21.21,0,0,0-.19,0Zm-13.78-8c-.05,0,0,.08,0,.12l1.63.94a.28.28,0,0,0,.2,0l1.27-.74c.05,0,0-.08,0-.11l-1.64-.94a.21.21,0,0,0-.19,0Zm16,9.25s0,.08,0,.12l1.64.94a.25.25,0,0,0,.19,0l1.27-.74s0-.08,0-.11l-1.64-.94a.21.21,0,0,0-.19,0Zm-20.51-11.84c-.05,0,0,.08,0,.11l1.63.95a.23.23,0,0,0,.2,0l1.27-.73c.05,0,0-.08,0-.11l-1.63-.94a.19.19,0,0,0-.19,0Zm-6.94-4c-.05,0,0,.07,0,.11l1.33.76a.19.19,0,0,0,.19,0l1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0Zm-2.88-3.76,1.27-.73c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,181.49,229.69Zm7.91.38,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,189.4,230.07Zm5.15,7.16,1.27-.73c.05,0,.05-.08,0-.11l-3.88-2.24a.19.19,0,0,0-.19,0l-1.27.73c-.05,0,0,.08,0,.11l3.88,2.24A.19.19,0,0,0,194.55,237.23Zm-9.85-7.15c.05,0,0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm.54-.32,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74c-.05,0,0,.08,0,.11l1.33.76A.19.19,0,0,0,185.24,229.76Zm11.25,8.59,1.27-.73c.05,0,.05-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,196.49,238.35Zm-7.51-5.8c.05,0,.05-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0ZM206.19,244l1.26-.74c.05,0,.05-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77A.24.24,0,0,0,206.19,244Zm-1.94-1.12,1.27-.74s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.32.76A.24.24,0,0,0,204.25,242.83Zm3.87,2.24,1.27-.74c.05,0,.05-.08,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-1.27.73c-.05,0,0,.08,0,.11l1.32.77A.21.21,0,0,0,208.12,245.07Zm-7.75-4.48,1.27-.73c.05,0,0-.08,0-.12L200.3,239a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,200.37,240.59Zm1.94,1.12,1.27-.73s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73c-.05,0-.05.08,0,.12l1.33.76A.21.21,0,0,0,202.31,241.71Zm-3.88-2.24,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0-.05.07,0,.11l1.33.76A.19.19,0,0,0,198.43,239.47ZM188,223.69s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-.33.2s0,.07,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm10.57,5.57c.05,0,.05-.08,0-.11l-1.33-.77a.25.25,0,0,0-.19,0l-1.27.74s0,.08,0,.11l1.33.76a.19.19,0,0,0,.19,0ZM194.68,227c.06,0,0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.26.73s0,.08,0,.11l1.32.77a.23.23,0,0,0,.2,0Zm6.25,3.61s0-.08,0-.12l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-4.31-2.49s0-.08,0-.11l-1.32-.77a.23.23,0,0,0-.2,0l-1.27.73s0,.08,0,.11l1.32.77a.21.21,0,0,0,.19,0Zm8.19,4.72c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Zm-1.94-1.12s0-.07,0-.11l-1.33-.76a.21.21,0,0,0-.19,0l-1.27.73s0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-11-5.81s0-.08,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-.34.19c-.05,0,0,.08,0,.12l1.33.76a.21.21,0,0,0,.19,0Zm-5.81-3.36c.05,0,0-.07,0-.11l-1.32-.76a.24.24,0,0,0-.2,0l-.33.2c-.05,0-.05.08,0,.11l1.32.76a.21.21,0,0,0,.2,0Zm-1.74,1c.05,0,.05-.08,0-.11L183,222.7a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76a.19.19,0,0,0,.19,0Zm-4.77,5,1.27-.73c.05,0,0-.08,0-.11l-1.33-.77a.21.21,0,0,0-.19,0l-1.27.74c-.05,0,0,.07,0,.11l1.33.76A.19.19,0,0,0,179.55,228.57Zm10.38-3.76s0-.07,0-.11l-1.32-.76a.21.21,0,0,0-.2,0l-.34.2c-.05,0,0,.07,0,.11l1.32.76a.24.24,0,0,0,.2,0ZM206.75,234c.05,0,0-.07,0-.11l-1.33-.76a.19.19,0,0,0-.19,0l-1.27.73s0,.08,0,.11l1.33.77a.21.21,0,0,0,.19,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.74 244.72 199.47 244.87 192.24 249.04 179.39 241.63 179.13 241.47 186.62 237.15 199.74 244.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.47 244.87 192.24 249.04 179.39 241.63 186.62 237.46 199.47 244.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "199.47 244.87 192.24 249.04 179.39 241.63 186.62 237.46 199.47 244.87",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,243.36a1.38,1.38,0,0,1-.37.16,1.79,1.79,0,0,0,.37-.15l.11-.08A.41.41,0,0,1,236.79,243.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,243.48l0,0h0Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,194.84a3.35,3.35,0,0,1-1.69-.44l-25.62-14.79,36.62-21.14,23.34,13.47a2.62,2.62,0,0,1,0,4.59l-31,17.87A3.35,3.35,0,0,1,276.48,194.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,161.11l23.49,12.37.48.75v.62a.88.88,0,0,1-.48.76l-30.95,17.87a1.74,1.74,0,0,1-1.62,0l-23-13.26v-.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,193.07a1.65,1.65,0,0,0,.81-.2L308.24,175a.83.83,0,0,0,0-1.51l-22.45-13-33.08,19.1,23,13.26A1.65,1.65,0,0,0,276.48,193.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,158.72,308,171.53l.23.32v2.38h0a.39.39,0,0,1-.23.32l-31,17.88a1.25,1.25,0,0,1-1.1,0l-22.2-12.82v-2.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73,177.23l.27.16,3.62,2.08.67.39L275.93,190a1.19,1.19,0,0,0,1.1,0l31-17.87a.34.34,0,0,0,0-.64l-.3-.17-21.9-12.64L254,177.07l-.06,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,190.18v2.38a1.21,1.21,0,0,0,.55-.13l31-17.88a.37.37,0,0,0,.22-.32v-2.38a.38.38,0,0,1-.22.32L277,190A1.1,1.1,0,0,1,276.48,190.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73,176.91l4,2.31.63.36,17.58,10.14a1.19,1.19,0,0,0,1.1,0l27.72-16,.7-.4a6.69,6.69,0,0,0,2.24-2l.06-.08a.52.52,0,0,0,.06-.16.48.48,0,0,0-.38-.56,10.52,10.52,0,0,1-2.09-.88h0L285.79,158.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,176.63a.32.32,0,0,1,0,.6,1.17,1.17,0,0,1-1,0c-.29-.17-.29-.44,0-.6A1.08,1.08,0,0,1,257.86,176.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,176.31a4.56,4.56,0,0,0,0,.51l.36-.21c0-.1,0-.2,0-.3a1.42,1.42,0,0,1,.52-1.28.79.79,0,0,1,.37-.1,1.28,1.28,0,0,1,.63.2,3.85,3.85,0,0,1,1.55,2.22,1.17,1.17,0,0,0,.38,0,4.28,4.28,0,0,0-1.74-2.5,1.34,1.34,0,0,0-1.38-.1A1.76,1.76,0,0,0,253.84,176.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.92,177a.29.29,0,0,0,0,.09l.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,174.84a.31.31,0,0,1,0,.59,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.59A1.1,1.1,0,0,1,261,174.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,174.51a4.67,4.67,0,0,0,0,.52l.37-.21a1.56,1.56,0,0,1,0-.31,1.41,1.41,0,0,1,.52-1.27.69.69,0,0,1,.37-.1,1.34,1.34,0,0,1,.63.19,3.9,3.9,0,0,1,1.56,2.22,1,1,0,0,0,.38,0A4.36,4.36,0,0,0,259,173a1.36,1.36,0,0,0-1.38-.09A1.77,1.77,0,0,0,257,174.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.07,173.05a.31.31,0,0,1,0,.59,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.59A1.1,1.1,0,0,1,264.07,173.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.05,172.72a3.12,3.12,0,0,0,0,.52l.36-.21c0-.1,0-.21,0-.31a1.4,1.4,0,0,1,.52-1.27.71.71,0,0,1,.37-.1,1.41,1.41,0,0,1,.64.19,3.93,3.93,0,0,1,1.55,2.22,1,1,0,0,0,.38,0,4.35,4.35,0,0,0-1.74-2.51,1.35,1.35,0,0,0-1.39-.09A1.76,1.76,0,0,0,260.05,172.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,171.26c.28.16.29.43,0,.59a1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.59A1.1,1.1,0,0,1,267.17,171.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,170.93a3.12,3.12,0,0,0,0,.52l.36-.21c0-.1,0-.21,0-.31a1.38,1.38,0,0,1,.53-1.27.66.66,0,0,1,.37-.1,1.41,1.41,0,0,1,.63.19,3.88,3.88,0,0,1,1.55,2.22,1,1,0,0,0,.38,0,4.3,4.3,0,0,0-1.74-2.51,1.38,1.38,0,0,0-1.39-.1A1.79,1.79,0,0,0,263.15,170.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.27,169.46c.29.17.29.44,0,.6a1.08,1.08,0,0,1-1,0c-.29-.16-.29-.43,0-.6A1.14,1.14,0,0,1,270.27,169.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.25,169.14a4.38,4.38,0,0,0,0,.51l.36-.2c0-.11,0-.21,0-.31a1.43,1.43,0,0,1,.52-1.28.75.75,0,0,1,.37-.09,1.26,1.26,0,0,1,.63.19,3.85,3.85,0,0,1,1.55,2.22,1.17,1.17,0,0,0,.38,0,4.27,4.27,0,0,0-1.74-2.51,1.36,1.36,0,0,0-1.38-.1A1.77,1.77,0,0,0,266.25,169.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.38,167.67a.32.32,0,0,1,0,.6,1.17,1.17,0,0,1-1,0c-.29-.17-.29-.43,0-.6A1.17,1.17,0,0,1,273.38,167.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.36,167.35a2.92,2.92,0,0,0,0,.51l.36-.21a1.51,1.51,0,0,1,0-.3,1.42,1.42,0,0,1,.52-1.28.78.78,0,0,1,.37-.09,1.23,1.23,0,0,1,.63.19,3.86,3.86,0,0,1,1.56,2.22,1,1,0,0,0,.38,0,4.34,4.34,0,0,0-1.75-2.5,1.36,1.36,0,0,0-1.38-.1A1.78,1.78,0,0,0,269.36,167.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.48,165.88a.32.32,0,0,1,0,.6,1.17,1.17,0,0,1-1,0,.32.32,0,0,1,0-.6A1.17,1.17,0,0,1,276.48,165.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.46,165.56a2.92,2.92,0,0,0,0,.51l.36-.21c0-.1,0-.2,0-.3a1.42,1.42,0,0,1,.52-1.28.81.81,0,0,1,.37-.09,1.29,1.29,0,0,1,.64.19,3.9,3.9,0,0,1,1.55,2.22,1,1,0,0,0,.38,0,4.32,4.32,0,0,0-1.74-2.5,1.36,1.36,0,0,0-1.39-.1A1.78,1.78,0,0,0,272.46,165.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,164.09c.29.17.29.43,0,.6a1.17,1.17,0,0,1-1,0,.32.32,0,0,1,0-.6A1.17,1.17,0,0,1,279.58,164.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.56,163.77a4.56,4.56,0,0,0,0,.51l.36-.21c0-.1,0-.2,0-.3a1.43,1.43,0,0,1,.53-1.28.76.76,0,0,1,.37-.1,1.28,1.28,0,0,1,.63.2,3.85,3.85,0,0,1,1.55,2.22,1,1,0,0,0,.38-.05,4.28,4.28,0,0,0-1.74-2.5,1.34,1.34,0,0,0-1.38-.1A1.76,1.76,0,0,0,275.56,163.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.68,162.3a.32.32,0,0,1,0,.6,1.17,1.17,0,0,1-1,0c-.29-.17-.29-.44,0-.6A1.08,1.08,0,0,1,282.68,162.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.66,162a4.55,4.55,0,0,0,0,.52l.36-.21c0-.1,0-.2,0-.31a1.41,1.41,0,0,1,.52-1.27.76.76,0,0,1,.37-.1,1.28,1.28,0,0,1,.63.2,3.85,3.85,0,0,1,1.55,2.22,1.17,1.17,0,0,0,.38-.05,4.28,4.28,0,0,0-1.74-2.5,1.34,1.34,0,0,0-1.38-.1A1.75,1.75,0,0,0,278.66,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,160.51a.31.31,0,0,1,0,.59,1.1,1.1,0,0,1-1,0,.31.31,0,0,1,0-.59A1.1,1.1,0,0,1,285.79,160.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.77,160.18a3.12,3.12,0,0,0,0,.52l.36-.21a1.56,1.56,0,0,1,0-.31,1.41,1.41,0,0,1,.52-1.27.69.69,0,0,1,.37-.1,1.25,1.25,0,0,1,.63.2,3.83,3.83,0,0,1,1.56,2.22,1.2,1.2,0,0,0,.38,0,4.39,4.39,0,0,0-1.74-2.51,1.38,1.38,0,0,0-1.39-.09A1.77,1.77,0,0,0,281.77,160.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,186.47a.33.33,0,0,1-.14,0l-17.08-9.86a.28.28,0,0,1-.1-.39.29.29,0,0,1,.39-.11l17.07,9.87a.27.27,0,0,1,.11.38A.27.27,0,0,1,279.58,186.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.65,185.27a.23.23,0,0,1-.14,0l-17.08-9.86a.28.28,0,0,1-.1-.39.28.28,0,0,1,.38-.1l17.08,9.86a.28.28,0,0,1,.11.39A.3.3,0,0,1,281.65,185.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.72,184.08a.23.23,0,0,1-.14,0l-17.08-9.86a.28.28,0,1,1,.28-.49l17.08,9.86a.28.28,0,0,1,.1.39A.27.27,0,0,1,283.72,184.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,182.88a.32.32,0,0,1-.14,0L268.57,173a.27.27,0,0,1-.11-.38.28.28,0,0,1,.39-.11l17.08,9.86a.28.28,0,0,1,.1.39A.27.27,0,0,1,285.79,182.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.86,181.69a.28.28,0,0,1-.15,0l-17.08-9.86a.28.28,0,1,1,.29-.49L288,181.16a.29.29,0,0,1,.1.39A.28.28,0,0,1,287.86,181.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.92,180.5a.43.43,0,0,1-.14,0L272.7,170.6a.29.29,0,0,1-.1-.39.28.28,0,0,1,.39-.11L290.07,180a.29.29,0,0,1,.1.39A.29.29,0,0,1,289.92,180.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,179.3a.25.25,0,0,1-.14,0l-17.08-9.86a.28.28,0,1,1,.29-.49l17.08,9.86a.29.29,0,0,1,.1.39A.29.29,0,0,1,292,179.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.06,178.11a.33.33,0,0,1-.14,0l-17.08-9.86a.28.28,0,0,1-.1-.39.29.29,0,0,1,.39-.11l17.07,9.87a.27.27,0,0,1,.11.38A.29.29,0,0,1,294.06,178.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.13,176.91a.23.23,0,0,1-.14,0L278.91,167a.28.28,0,1,1,.28-.49l17.08,9.86a.28.28,0,0,1,.11.39A.3.3,0,0,1,296.13,176.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.2,175.72a.23.23,0,0,1-.14,0L281,165.82a.28.28,0,1,1,.28-.49l17.08,9.86a.29.29,0,0,1,.11.39A.3.3,0,0,1,298.2,175.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.27,174.52a.32.32,0,0,1-.14,0l-17.08-9.87a.27.27,0,0,1-.11-.38.29.29,0,0,1,.39-.11L300.41,174a.28.28,0,0,1,.1.39A.27.27,0,0,1,300.27,174.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.34,173.33a.28.28,0,0,1-.15,0l-17.08-9.86a.29.29,0,0,1-.1-.39.28.28,0,0,1,.39-.1l17.08,9.86a.29.29,0,0,1,.1.39A.28.28,0,0,1,302.34,173.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.4,172.14a.43.43,0,0,1-.14,0l-17.08-9.86a.29.29,0,0,1-.1-.39.28.28,0,0,1,.39-.11l17.08,9.86a.29.29,0,0,1,.1.39A.29.29,0,0,1,304.4,172.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48,187.66a.23.23,0,0,1-.14,0l-18.07-10.45a.28.28,0,0,1-.1-.38.28.28,0,0,1,.39-.11l18.06,10.45a.28.28,0,0,1,.11.39A.3.3,0,0,1,277.48,187.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.86,175.07a2.61,2.61,0,0,0,.88-.9.77.77,0,0,1,.38-.09c.5.07.08.26,0,.45s0,.12.09.11c.35-.06,1.19-.26,1,.3a.08.08,0,0,0,.05.1c.11,0,.58.1.53.22a.08.08,0,0,0,.07.11,8.23,8.23,0,0,1,1.11,0,2.49,2.49,0,0,1,.5.05c.11.14-.07.42-.12.51a.09.09,0,0,0,0,.13c.19.08.34.19.21.4a.08.08,0,0,0,0,.12c.47.13,1.32-.26,1.45.31.08.34,0,.42.46.39.08,0,.14-.16,0-.16-.46,0-.12-.52-.38-.7s-.88.16-1.17,0,.05-.19-.12-.4c0-.05-.16,0-.18-.08s-.07-.07-.09-.07a.4.4,0,0,0,0-.13c0-.09.06-.08.07-.14.11-.52-.74-.4-1.08-.43a4.25,4.25,0,0,1-.62,0s0-.13,0-.15-.49-.18-.5-.2.11-.2.05-.31c-.13-.27-.72-.12-.94-.12l-.16,0a.18.18,0,0,0,.14-.15c0-.07.05-.11,0-.2s-.17-.17-.31-.19a1.19,1.19,0,0,0-.45.08.81.81,0,0,0,.07-.47c-.13-.52-.71-.14-1,0-.07,0-.1.17,0,.14a2.19,2.19,0,0,1,.67-.19c.27.05.07.46-.09.71l-.34.18a1.47,1.47,0,0,0-.7.44C268.2,175.13,268.53,175.24,268.86,175.07Zm.19-.55.26-.13a1.15,1.15,0,0,1-.44.46s-.37.14-.26,0A1,1,0,0,1,269.05,174.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.23,179.19a.05.05,0,0,0,0,.07c.4.13.78-.34.92-.81.15,0,.46-.07.52.16,0,0-.08.21-.09.25s0,.07.08.08c.22,0,.92-.26.81.12a.08.08,0,0,0,0,.09c.19.12.59-.09.64.19,0,.13-.24.25-.1.44s.32.05.45,0,.16-.11.25-.08,0,.09.05.13.05.1.1.13.14,0,.2,0,.1-.08.15-.08a.77.77,0,0,1,.27.07s.4.18.36.11c.06.11-.18.29-.06.46s.71,0,.88,0,.14-.17,0-.17l-.41,0c-.36-.15-.26-.26-.2-.44s0-.11-.06-.1c-.24,0-.41-.22-.59-.22a3,3,0,0,0-.29.11c-.28,0-.15-.09-.15-.28a.07.07,0,0,0-.1-.06c-.16.06-.58.39-.59,0,0-.06.17-.16.19-.24s-.06-.23-.23-.27a.85.85,0,0,0-.35.05c-.44.07-.07,0-.22-.12a.43.43,0,0,0-.41-.13,1.59,1.59,0,0,1-.29,0c-.24-.06-.08,0-.09-.16s.09-.19,0-.31-.19-.2-.39-.16a1.48,1.48,0,0,0-.39.13c0-.32-.05-.59-.36-.58-.09,0-.16.15-.05.16s.22.3.15.55C276.62,178.56,276.25,178.88,276.23,179.19Zm.39-.29a1,1,0,0,1,.28-.28l0,.11C276.81,178.79,276.54,179.13,276.62,178.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2,181.19a2.6,2.6,0,0,0,.87-.9.8.8,0,0,1,.39-.09c.5.07.08.26,0,.45a.08.08,0,0,0,.1.11c.35-.06,1.19-.26,1,.3a.07.07,0,0,0,0,.1c.1,0,.58.1.53.22a.08.08,0,0,0,.07.11,8.08,8.08,0,0,1,1.1,0,2.67,2.67,0,0,1,.51.05c.11.14-.07.42-.12.51a.09.09,0,0,0,0,.13c.19.08.33.19.21.4a.08.08,0,0,0,0,.12c.48.13,1.32-.26,1.46.31.08.34,0,.42.46.39.07,0,.13-.16,0-.16-.45,0-.12-.52-.38-.7s-.88.16-1.16,0,0-.19-.12-.4c0,0-.16,0-.19-.08S276,182,276,182a.4.4,0,0,0,0-.13c0-.09.05-.08.06-.14.12-.52-.73-.4-1.07-.43a4.25,4.25,0,0,1-.62,0s0-.13,0-.15-.5-.18-.51-.2.11-.2.06-.31c-.14-.27-.73-.12-.94-.12l-.16,0a.18.18,0,0,0,.14-.15c0-.07.05-.11,0-.2s-.18-.17-.32-.19a1.26,1.26,0,0,0-.45.08.74.74,0,0,0,.07-.47c-.12-.52-.7-.14-1,0-.07,0-.09.17,0,.14s.5-.22.66-.19.07.46-.09.71l-.33.18a1.47,1.47,0,0,0-.7.44C270.53,181.25,270.87,181.36,271.2,181.19Zm.19-.55.26-.13a1.22,1.22,0,0,1-.44.46s-.37.14-.27,0A1.06,1.06,0,0,1,271.39,180.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.77,177.38a.08.08,0,0,0,.05.07c.41.12.78-.35.92-.82.15,0,.47-.07.52.17a1.67,1.67,0,0,0-.08.24c0,.05,0,.07.07.08.22,0,.92-.26.81.12a.08.08,0,0,0,0,.09c.18.12.58-.09.64.19,0,.13-.25.26-.1.44s.31,0,.45,0,.16-.12.25-.09,0,.09,0,.13.06.11.1.13.14,0,.21,0,.09-.08.14-.08a1.15,1.15,0,0,1,.28.07s.39.18.35.11c.06.11-.18.3-.06.46s.72,0,.88,0,.15-.17,0-.17-.4.06-.41.05c-.35-.15-.26-.26-.19-.43s0-.12-.07-.11c-.24,0-.4-.22-.59-.22s-.25.11-.29.11c-.28,0-.14-.08-.15-.28a.07.07,0,0,0-.1-.06c-.16.06-.58.39-.59,0,0,0,.18-.16.19-.24s-.06-.23-.22-.27a.83.83,0,0,0-.35.05c-.45.07-.07,0-.22-.12a.45.45,0,0,0-.42-.13.92.92,0,0,1-.28,0c-.25-.06-.08,0-.09-.16s.09-.19.05-.31-.2-.2-.4-.16a1.9,1.9,0,0,0-.38.13c0-.32-.06-.59-.37-.58-.08,0-.16.15-.05.17s.22.3.16.54C265.16,176.74,264.8,177.06,264.77,177.38Zm.39-.3a1,1,0,0,1,.29-.28.36.36,0,0,1-.06.11C265.35,177,265.08,177.32,265.16,177.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.48,168.1a2.6,2.6,0,0,0,.87-.9.7.7,0,0,1,.39-.09c.5.07.08.26,0,.45a.09.09,0,0,0,.1.11c.35-.06,1.19-.27,1,.3a.07.07,0,0,0,.05.1c.1,0,.58.1.53.22a.08.08,0,0,0,.07.1,10.1,10.1,0,0,1,1.1,0,3.76,3.76,0,0,1,.51.06c.11.13-.07.42-.12.51a.08.08,0,0,0,0,.12c.19.09.33.2.21.4a.09.09,0,0,0,0,.13c.48.13,1.32-.26,1.46.3.08.35,0,.43.46.39.07,0,.13-.15,0-.15-.45,0-.12-.52-.38-.7s-.88.16-1.16,0,0-.2-.12-.4-.16,0-.19-.08-.07-.07-.08-.07a.4.4,0,0,0,0-.13c0-.09.05-.08.06-.14.12-.53-.73-.4-1.07-.43-.13,0-.56,0-.62,0s0-.13,0-.15-.5-.19-.51-.21.12-.19.06-.3c-.14-.27-.73-.13-.94-.12h-.16a.16.16,0,0,0,.14-.14c0-.07.05-.11,0-.21s-.17-.17-.32-.18a1.07,1.07,0,0,0-.45.08.68.68,0,0,0,.07-.47c-.12-.52-.7-.14-1,0-.07,0-.09.18,0,.15s.5-.23.66-.2.07.47-.09.72c-.12.06-.23.13-.33.17a1.49,1.49,0,0,0-.7.45C280.81,168.16,281.15,168.27,281.48,168.1Zm.19-.55.26-.14a1.33,1.33,0,0,1-.44.47s-.37.13-.27,0A1,1,0,0,1,281.67,167.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.84,172.22a.08.08,0,0,0,.05.07c.41.13.78-.35.92-.82.15,0,.47-.06.53.17a2.07,2.07,0,0,0-.09.24.07.07,0,0,0,.07.08c.23,0,.93-.26.81.13a.06.06,0,0,0,0,.08c.18.13.58-.08.64.2,0,.12-.25.25-.1.44s.32,0,.45,0,.16-.12.25-.09,0,.1,0,.14.06.1.11.13.13,0,.2,0,.09-.07.14-.08a1.15,1.15,0,0,1,.28.08s.39.18.35.11c.06.1-.17.29,0,.45s.71,0,.87,0,.15-.18.05-.17l-.42,0c-.35-.16-.26-.26-.19-.44a.07.07,0,0,0-.07-.11c-.24,0-.4-.22-.58-.21a2.24,2.24,0,0,0-.29.11c-.29,0-.15-.09-.16-.28a.08.08,0,0,0-.1-.07c-.16.06-.57.4-.58,0,0,0,.17-.16.18-.24s-.06-.23-.22-.26a1,1,0,0,0-.35,0c-.45.08-.07,0-.22-.11s-.17-.14-.42-.13c-.07,0-.22,0-.28,0-.24-.07-.08,0-.09-.16s.09-.19,0-.31-.2-.2-.4-.16a1.43,1.43,0,0,0-.38.13c0-.33-.06-.6-.37-.59-.08,0-.16.16-.05.17s.22.3.16.55C289.23,171.59,288.87,171.91,288.84,172.22Zm.39-.29a.86.86,0,0,1,.29-.29.36.36,0,0,1-.06.11C289.43,171.82,289.15,172.16,289.23,171.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.82,174.22a2.69,2.69,0,0,0,.87-.9.69.69,0,0,1,.38-.09c.5.07.08.26,0,.45a.08.08,0,0,0,.09.11c.35-.06,1.19-.27,1,.3a.07.07,0,0,0,0,.1c.11,0,.59.1.53.22a.08.08,0,0,0,.07.1,10.28,10.28,0,0,1,1.11,0,3.43,3.43,0,0,1,.5.06c.11.13-.07.42-.12.51a.07.07,0,0,0,0,.12c.18.09.33.2.2.4a.09.09,0,0,0,0,.13c.47.13,1.32-.26,1.45.3.09.35,0,.43.46.39.08,0,.14-.15,0-.15-.46,0-.12-.52-.38-.7s-.88.16-1.17,0,0-.2-.11-.4c-.05,0-.16,0-.19-.08s-.07-.07-.08-.07,0-.05,0-.13.06-.08.07-.14c.11-.53-.73-.4-1.08-.43-.12,0-.55,0-.62,0s0-.13,0-.15-.49-.19-.5-.21.11-.19.05-.3c-.13-.27-.72-.13-.94-.12h-.16a.17.17,0,0,0,.15-.14c0-.07,0-.11,0-.21s-.17-.17-.31-.18a1,1,0,0,0-.45.08.81.81,0,0,0,.07-.47c-.13-.52-.71-.14-1,0-.07,0-.09.18,0,.15s.49-.23.66-.2.07.47-.09.72l-.34.17a1.49,1.49,0,0,0-.7.45C283.15,174.28,283.49,174.39,283.82,174.22Zm.18-.55.26-.14a1.17,1.17,0,0,1-.44.47s-.36.13-.26,0A1,1,0,0,1,284,173.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,170.4s0,.06.05.07c.4.13.78-.34.92-.81.15,0,.47-.07.52.16,0,0-.08.21-.09.25s0,.07.08.08c.22,0,.92-.27.81.12a.1.1,0,0,0,0,.09c.19.12.59-.09.64.19,0,.12-.24.25-.1.44s.32,0,.45,0,.16-.12.25-.08,0,.09.05.13.05.1.1.13.14,0,.2,0,.1-.07.15-.07a.77.77,0,0,1,.27.07s.4.18.36.11c.06.1-.18.29-.06.45s.71,0,.88,0,.14-.17,0-.17l-.41.05c-.36-.15-.26-.26-.2-.44s0-.11-.06-.1c-.24,0-.41-.22-.59-.22a3,3,0,0,0-.29.11c-.28,0-.15-.09-.15-.28a.07.07,0,0,0-.1-.06c-.16.06-.58.39-.59,0,0-.06.17-.16.19-.25s-.06-.23-.23-.26a.85.85,0,0,0-.35,0c-.44.07-.07,0-.22-.12s-.17-.14-.41-.13c-.08,0-.22,0-.29,0-.24-.07-.08,0-.09-.16s.09-.19.05-.31-.19-.2-.39-.16a1.48,1.48,0,0,0-.39.13c0-.33-.05-.59-.36-.58-.09,0-.16.15-.05.16s.22.3.16.55C277.78,169.77,277.41,170.09,277.39,170.4Zm.39-.29c0-.07.15-.18.28-.28l-.05.11C278,170,277.7,170.34,277.78,170.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.52,178.43a2.69,2.69,0,0,0,.87-.9.7.7,0,0,1,.39-.09c.5.07.08.26,0,.45a.08.08,0,0,0,.1.11c.35-.06,1.19-.27,1,.3,0,0,0,.09,0,.1s.59.1.54.22a.07.07,0,0,0,.07.1c.37,0,.73,0,1.1,0a3.76,3.76,0,0,1,.51.06c.11.14-.07.42-.13.51a.08.08,0,0,0,0,.12c.19.09.33.2.21.4a.09.09,0,0,0,0,.13c.48.13,1.32-.26,1.46.3.08.35,0,.43.46.4.07,0,.13-.16,0-.16-.45,0-.12-.52-.38-.7s-.88.16-1.16,0,0-.19-.12-.4c0,0-.16,0-.19-.08s-.07-.07-.08-.07a.4.4,0,0,0,0-.13c0-.09.05-.08.06-.14.11-.53-.73-.4-1.07-.43a4.39,4.39,0,0,1-.63,0s0-.13,0-.15-.5-.19-.51-.21.11-.19.06-.3c-.14-.27-.73-.13-.94-.12h-.17a.17.17,0,0,0,.15-.14.43.43,0,0,0,0-.2c0-.17-.18-.18-.32-.19a1.07,1.07,0,0,0-.45.08.74.74,0,0,0,.07-.47c-.12-.52-.7-.14-1,0-.07,0-.09.17,0,.14s.5-.23.66-.2.07.47-.09.72c-.12.06-.23.13-.33.17a1.57,1.57,0,0,0-.7.45C281.85,178.49,282.19,178.6,282.52,178.43Zm.19-.55.25-.13a1.26,1.26,0,0,1-.43.46s-.37.13-.27,0A1.12,1.12,0,0,1,282.71,177.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.18,175a.08.08,0,0,0,.05.07c.41.13.78-.35.92-.82.15,0,.47-.06.52.17a2.23,2.23,0,0,0-.08.24c0,.05,0,.07.07.08.22,0,.92-.26.81.13a.07.07,0,0,0,0,.08c.18.13.58-.08.64.19s-.25.26-.1.45.31,0,.45,0,.16-.12.25-.09,0,.09,0,.14.06.1.1.13.14,0,.21,0,.09-.08.14-.08a1.15,1.15,0,0,1,.28.08s.39.18.35.11c.06.1-.18.29-.06.45s.72,0,.88,0,.15-.18,0-.18l-.41.06c-.35-.16-.26-.26-.19-.44a.08.08,0,0,0-.07-.11c-.24,0-.4-.22-.59-.21s-.25.11-.29.1c-.28,0-.14-.08-.15-.28s0-.07-.1-.06-.58.39-.59,0c0-.05.18-.16.19-.24s-.06-.23-.22-.27a1,1,0,0,0-.35,0c-.45.07-.07,0-.22-.12a.42.42,0,0,0-.42-.12,1.37,1.37,0,0,1-.28,0c-.25-.06-.08,0-.09-.15s.09-.19.05-.32-.2-.19-.4-.16a1.9,1.9,0,0,0-.38.13c0-.32-.06-.59-.37-.58-.08,0-.16.15,0,.17s.22.3.16.55C277.57,174.36,277.21,174.69,277.18,175Zm.39-.3a1,1,0,0,1,.29-.28.36.36,0,0,1-.06.11C277.76,174.6,277.49,174.94,277.57,174.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,171.05a1.19,1.19,0,0,1,0,.5.08.08,0,0,0,.08.08c.22,0,.92-.26.81.13a.08.08,0,0,0,0,.08c.19.13.59-.08.64.2,0,.12-.24.25-.1.44s.32,0,.45,0,.16-.12.25-.09,0,.09.05.14.05.1.1.13.14,0,.2,0,.1-.08.15-.08a1.07,1.07,0,0,1,.27.08s.4.18.36.11c.06.1-.18.29-.06.45s.71,0,.88,0,.14-.18,0-.18l-.41.06c-.36-.16-.26-.26-.2-.44s0-.11-.06-.11c-.24,0-.41-.22-.59-.21s-.26.11-.29.1c-.28,0-.15-.08-.15-.28,0,0-.06-.07-.1-.06s-.58.4-.59,0c0-.05.17-.16.19-.24s-.06-.23-.23-.27a1.06,1.06,0,0,0-.35.05c-.44.07-.07,0-.22-.11s-.17-.14-.41-.13c-.08,0-.23,0-.29,0-.24-.07-.08,0-.09-.16s.09-.19.05-.32-.32-.32-.39-.08a.14.14,0,0,0,0,.09A.36.36,0,0,0,273.21,171.05Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-90",
    d: "M250.49,291.69a2.83,2.83,0,0,1-1.37-.33l-22.87-13.2a1.14,1.14,0,0,1,0-2.1l4.08-2.35-2-1.13a1.26,1.26,0,0,1-.7-1.05,1.23,1.23,0,0,1,.7-1L262,251.06a2.93,2.93,0,0,1,2.74,0l22.87,13.2a1.23,1.23,0,0,1,.7,1,1.25,1.25,0,0,1-.7,1.05l-4.08,2.36,1.95,1.13a1.21,1.21,0,0,1,.7,1,1.25,1.25,0,0,1-.69,1.05l-33.66,19.43A2.83,2.83,0,0,1,250.49,291.69Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,269.11a.8.8,0,0,0-.48-.66l-22.86-13.21a2.58,2.58,0,0,0-2.3,0l-33.66,19.43a.83.83,0,0,0-.47.67v1a.81.81,0,0,0,.47.66l22.87,13.2a2.52,2.52,0,0,0,2.3,0l33.65-19.43a.79.79,0,0,0,.48-.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,274.67l33.66-19.43a2.58,2.58,0,0,1,2.3,0l22.86,13.21a.69.69,0,0,1,0,1.32L251.64,289.2a2.52,2.52,0,0,1-2.3,0L226.47,276A.7.7,0,0,1,226.47,274.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.49,289.48v1a2.27,2.27,0,0,1-1.15-.27L226.48,277a.8.8,0,0,1-.48-.66v-1a.81.81,0,0,0,.48.66l22.86,13.2A2.28,2.28,0,0,0,250.49,289.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.9,263.53a.8.8,0,0,0-.48-.66l-22.87-13.2a2.52,2.52,0,0,0-2.3,0L228.6,269.1a.8.8,0,0,0-.48.66v1a.82.82,0,0,0,.48.66l22.87,13.2a2.52,2.52,0,0,0,2.3,0l33.65-19.43a.83.83,0,0,0,.48-.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.6,269.1l33.65-19.43a2.52,2.52,0,0,1,2.3,0l22.87,13.2a.7.7,0,0,1,0,1.33l-33.65,19.43a2.58,2.58,0,0,1-2.3,0L228.6,270.42A.7.7,0,0,1,228.6,269.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.62,283.9v1a2.32,2.32,0,0,1-1.16-.28L228.6,271.47a.81.81,0,0,1-.47-.67v-1a.77.77,0,0,0,.47.66l22.86,13.21A2.42,2.42,0,0,0,252.62,283.9Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329,247.77a2.7,2.7,0,0,1-1.31-.32l-36.8-21.25a1.51,1.51,0,0,1-.81-1.26,1.53,1.53,0,0,1,.76-1.3l30.39-19.32a2.9,2.9,0,0,1,2.76-.06l10.94,6.33a2,2,0,0,1,.78,2.62l-.44.87a.36.36,0,0,0,.13.47l22.06,12.84a1.44,1.44,0,0,1,.05,2.56l-27.07,17.43A2.69,2.69,0,0,1,329,247.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.53,245.59l27.57-16a.59.59,0,0,0,0-1.13L319.29,207a2.18,2.18,0,0,0-2,0L290,222.77a.6.6,0,0,0,0,1.14l37.56,21.68A2.18,2.18,0,0,0,329.53,245.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.53,245.59l27.57-16a.59.59,0,0,0,0-1.13L319.29,207a2.18,2.18,0,0,0-2,0L290,222.77a.6.6,0,0,0,0,1.14l37.56,21.68A2.18,2.18,0,0,0,329.53,245.59Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290,222.73,321,203A2.05,2.05,0,0,1,323,203l11.17,6.45a1.21,1.21,0,0,1,.46,1.58l-.45.89a1.21,1.21,0,0,0,.46,1.58l22.51,13.1a.64.64,0,0,1,0,1.19L329.5,245.54a2,2,0,0,1-1.93.05L290,223.91A.63.63,0,0,1,290,222.73Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-pencil--inject-90"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "freepik--shadow--inject-90",
    points: "299.89 200.96 265.02 221.05 269.21 223.47 303.84 203.24",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.29,202l4.15-4.93a.2.2,0,0,0-.19-.32l-6.33,1.4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,196.7h0l-6.33,1.4,1.25,2,.68-.41,4.42-2.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.25,196.7a.2.2,0,0,1,.19.32l-.81,1h0a1.08,1.08,0,0,0-.64-.93l-.1-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.29,215.38l.51-.31.61-.38,27.51-16.59a2.87,2.87,0,0,1,1.75,1.17,3,3,0,0,1,.62,2.68l-27.5,16.59-1.17.71C275.35,218.74,273,214.88,272.29,215.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.29,215.38l.51-.31.61-.38,27.51-16.59a3,3,0,0,1,2,1.57l-28.69,17.51c0,.07,0,.11,0,.11C273.61,216.19,272.7,215.1,272.29,215.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.23,214.2l1.14-.69c.32-.21,1,.37,1.52,1.14.75,1,1.22,2.46.8,2.74l-.85.51-.3.18c.43-.28,0-1.73-.79-2.75-.54-.74-1.15-1.3-1.49-1.15h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,214c.75-.49,3.07,3.39,2.32,3.88l-1.14.69c.75-.49-1.57-4.37-2.32-3.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.29,215.38l1.12-.69c.74-.48,3,3.25,2.38,3.85l0,0-1.14.68C275.35,218.74,273,214.88,272.29,215.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,196.78a.21.21,0,0,0-.16-.08A.21.21,0,0,1,307.45,196.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.51,218.27l4.78-2.89c.32-.21.95.35,1.51,1.11.76,1,1.24,2.47.82,2.76h0l-4.79,2.9c-1,.58-2.36-1.22-2.66-2.62A1.16,1.16,0,0,1,267.51,218.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,218.75a3.51,3.51,0,0,1,1.14,2.89.78.78,0,0,1-.44.58c-1,.31-2.22-1.36-2.5-2.69a1.16,1.16,0,0,1,.33-1.24C267.85,218.07,268.41,218.22,269,218.75Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.92,351.84c0-.16.95-9.79.95-9.79s-.69,1-6.24.49a30.7,30.7,0,0,1-6.2-1.43l-.37,7c-1,2.83-5.87,2.44-11.12,2.74-.88.05-1.79.06-2.71.06h-.05c-2.81.32-5.31,2.47-2,4.34s8.21,2,12.73,2C336.35,357.28,345.87,357.24,345.92,351.84Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.86,357.35a5.4,5.4,0,0,0,.1,2.89c.27,1,3.4,4.05,8.24,5.41s10.4.56,13.12.86,5.35,1.38,8.53,1.6,6.27.1,9-2.44c.42-1,.7-3.08.48-3.24C347.74,362,308.86,357.35,308.86,357.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41,349.12c-1.74,1.7-6,1.46-10.47,1.71-4.23.24-9.15-.42-11.81,1s-3.11,4.76,1.43,8.37a19.6,19.6,0,0,0,4.22,3c4.76,1.87,9.76.9,12.94,1.13,4.14.3,6.61,1.68,10.35,1.48,4.84-.26,7.64-2,8.24-3.4s-.38-11.77-2.38-11.21c0,0-.29,3.46-8.6,1.57C333.7,352,333.4,349.89,333.41,349.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,363.22s-1.61-10.76,4.47-12.34l.79,0s-.12-.73-2.53-.92c-4.62-.36-7.53.22-9.48,2.21a6,6,0,0,0-1.21,5.1C309.42,359.33,311.8,361.72,316.78,363.22Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.18,356.87s-.3-4.4,2.7-6.09a1.7,1.7,0,0,1,1.8-.07s-2.89.94-3,6.17c0,0-.1.36-.76.36C321.7,357.23,321.21,357.23,321.18,356.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.46,350.58s0-.14-.8-.15a1.37,1.37,0,0,0-.86.24s-2.2,1.44-1.88,6a.83.83,0,0,0,.86.57.66.66,0,0,0,.77-.59S326.23,351.85,328.46,350.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,350.24s-.18-.25-.74-.15c-.71.12-.82.42-.82.42s-1.4,2-.78,5.81c0,0,0,.65.94.56s.65-.79.65-.79S329.77,351.24,331,350.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.56,289.61c-.4,9.64-.07,54.44-.07,54.44s5.91,5,13.38,2.4L351.51,295Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.41,368.35c0-.16,1.76-9.36,1.76-9.36s-1.75,1.17-7.32.85a24.56,24.56,0,0,1-5.5-1l-.9,6.77c-.88,2.86-5.79,2.62-11,3.08-.88.07-1.8.11-2.71.14h-.06c-2.79.41-5.22,2.63-1.88,4.4s8.27,1.71,12.79,1.61C310,374.7,319.53,373.75,319.41,368.35Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.54,375.6a5.59,5.59,0,0,0,.19,2.89c.31,1,3.53,3.94,8.41,5.16s10.41.24,13.13.46,5.39,1.22,8.58,1.34,6.27-.09,8.9-2.71c.39-1,.61-3.1.39-3.26C321.55,379.06,282.54,375.6,282.54,375.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,366.64c-1.68,1.75-5.92,1.63-10.4,2-4.23.36-9.17-.14-11.78,1.4s-3,4.85,1.68,8.32a19.61,19.61,0,0,0,4.31,2.85c4.81,1.73,9.78.6,13,.74,4.14.17,6.65,1.48,10.39,1.17,4.83-.41,7.58-2.23,8.14-3.66s-.74-11.75-2.73-11.13c0,0-.18,3.46-8.55,1.83C307.21,369.47,306.85,367.4,306.83,366.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.64,381.23s-1.94-10.71,4.09-12.47l.79-.05s-.14-.73-2.55-.85c-4.64-.22-7.53.45-9.41,2.49a6,6,0,0,0-1.05,5.14C283.16,377.56,285.62,379.88,290.64,381.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.84,374.75s-.42-4.39,2.52-6.17a1.72,1.72,0,0,1,1.8-.12s-2.86,1-2.81,6.26c0,0-.08.36-.75.37C295.38,375.1,294.89,375.11,294.84,374.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.93,368.24s0-.14-.8-.13a1.33,1.33,0,0,0-.85.28s-2.16,1.5-1.7,6.08a.81.81,0,0,0,.87.54.67.67,0,0,0,.76-.61S299.74,369.58,301.93,368.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,367.82s-.19-.24-.75-.12-.8.45-.8.45-1.34,2.06-.6,5.82c0,0,.06.65,1,.54s.62-.81.62-.81S303.26,368.86,304.49,367.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.08,308.33c-1.13,10-2.19,38.86-2.93,53.29a19.91,19.91,0,0,0,14.4,1.6l10.28-51.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.76,426.57a1.21,1.21,0,0,1-1.2-1.21V348a1.21,1.21,0,1,1,2.41,0v77.4A1.21,1.21,0,0,1,374.76,426.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.65,398.39a1.2,1.2,0,0,1-1.12-.76L397.8,337.55a1.21,1.21,0,0,1,.67-1.56,1.22,1.22,0,0,1,1.57.68l23.73,60.08a1.19,1.19,0,0,1-.68,1.56A1.11,1.11,0,0,1,422.65,398.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8,391.18a1.18,1.18,0,0,1-.87-.38l-44.17-46.74L330.67,390.6a1.2,1.2,0,1,1-1.74-1.65l45-47.47a1.18,1.18,0,0,1,.87-.37h0a1.19,1.19,0,0,1,.88.38l45,47.66a1.21,1.21,0,0,1-.88,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.87,398.39a1.11,1.11,0,0,1-.44-.08,1.2,1.2,0,0,1-.68-1.56l23.74-60.08a1.2,1.2,0,1,1,2.24.88L328,397.63A1.2,1.2,0,0,1,326.87,398.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,321.41c-.86-4.85,3.09-8.64,10.53-13.66a175.83,175.83,0,0,1,21.57-12.12c6.22-2.86,12.59-2.59,20.56,1.5,11.08,5.69,44.4,25.9,44.4,25.9s-49.82,28.13-59.41,26.87-33.54-16.84-35.44-22.33S326.29,321.41,326.29,321.41Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.76,344c-7.16,6.48-14.63.9-26.46-6.77-13.39-8.69-16-15.8-16-15.8s0,5.33,1,7.83,3.16,5.32,12.81,12,16.65,10,23.14,11.22l5.12-.71",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,337.21c-13.39-8.69-16-15.8-16-15.8s0,5.33,1,7.83,3.16,5.32,12.81,12,16.65,10,23.14,11.22l5.12-.71.4-7.75C361.6,350.46,354.13,344.88,342.3,337.21Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,389.32l3.13,8.28a.76.76,0,0,1,0,.21.43.43,0,0,1,0,.16,1,1,0,0,1-.47.52,2.14,2.14,0,0,1-1.91,0,.85.85,0,0,1-.37-.39s0,0,0,0l0-.11-2.91-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,389.32l-3.14,8.28a.76.76,0,0,0,0,.21V398a1,1,0,0,0,.47.52,2.14,2.14,0,0,0,1.91,0,.88.88,0,0,0,.38-.39v0l0-.11,2.91-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.15,419.37v6.85a.7.7,0,0,1-.41.57,2.18,2.18,0,0,1-2,0,.7.7,0,0,1-.41-.57v-6.85A3,3,0,0,1,376.15,419.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,302.16s-40-12.06-46.92-14-20.28-5.11-24.17-3.37-5.88,3.77-6.23,9.39c-.08,1.06,0,6.2,0,6.2s20.24,8.24,36.07,8.24S407.72,302.16,407.72,302.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.85,297.15c2.51,8.56,3.3,16.93-2.7,23.1-4.35,4.49-22.42,20.51-38.25,15.66-17.7-5.43-38.83-20.79-38.83-20.79s-13.66.42-13.73-3.59c0-1-4.32-2.2-4.27-3.26.56-11.78,8.48-16.68,20.29-14.54,12.39,2.25,40.1,10.15,40.1,10.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.08,332.78c3-10.87,6.54-24.68,6.54-24.68l-16.33,5.15c-3.38,10.68-5.08,16.47-13.51,15.1s-36.71-13.23-36.71-13.23,21.13,15.36,38.83,20.79C374,338.08,381.52,336.07,388.08,332.78Z",
    style: {
      fill: "#37474f",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.25,234.21c5.4-1.21,11.27,2.7,14.62,11.19s11.33,29.5,12.7,35.16c.61,2.54-20.2,25.33-19.51,25,.21-.1-6.11-11-6.11-11l10.58-14.1-6.71-15.76Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.71,233.36c4.84-.11,10.69.79,14.52,8a139.87,139.87,0,0,1,11.33,27.8s-14.69,10.32-24.11,6.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.71 227.5 384.29 243.76 398.94 243.03 397.23 224 381.71 227.5",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.42,242.19c-1.35-4.44-6.16-8.95-11.88-8.82l-4.46.09c-.67,2.74-7.6,5.79-14.78,4.1q-3.24.85-5.95,1.75c-5.16,1.71-9.92,6-10.72,22.86,0,0-2,38.66-2.24,46.25,7.32,9.31,25.14,8,32.56,6.59,15.46-3,17.87-11.31,17.87-11.31s.84-28.23.65-40.43C415.31,252.9,415.35,245.24,414.42,242.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.86,207.54s-3.84,5.83-3.4,6.41,3.26,1.09,3.26,1.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.54,191.41c-7.78,1.64-10,5.06-10.76,17.41-.77,12.92.55,17,2.25,18.71,1.14,1.18,7.51,1.39,10.72.5,4-1.11,13.09-4.32,17.34-10.82,5-7.64,6.32-18,1-22.24C394.52,189,384.7,190.74,381.54,191.41Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.05,196.74l0,0a17.7,17.7,0,0,0,7.51,2.36,15.3,15.3,0,0,0,1.25,6.14c.48,1.37,2.2,5.68,3.92,3.25,1.24-1.75,2.36-3.35,4.82-3,4.05.61,4.59,5.77,2,8.9s-4.93,1.94-4.93,1.94.13,6.82,3.15,10.68c0,0,3.44,1.11,9.76-.24,3.89-.83,9.39-5.69,11.7-10.83,4.89-10.89,5.23-20.68-1.72-23.62-.75-5-4.7-7.27-9.2-8.3-6.24-1.43-12.6,2.61-18.66.17-1.27-.51-2.45-1.25-3.76-1.69a2.53,2.53,0,0,0-2.23.06,2.68,2.68,0,0,0-.92,1.73,4.8,4.8,0,0,0,.32,3.58,10.4,10.4,0,0,0-2.84-1,3.53,3.53,0,0,0-2.84.71,3.69,3.69,0,0,0-1.09,2.51A7.66,7.66,0,0,0,369.05,196.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.7,194l4.66-2.75A2.71,2.71,0,0,0,406.7,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.51,268.47c2.5,1.18,32.74,25.18,37.44,22.72s28.58-30.61,28.58-30.61a19.67,19.67,0,0,0,.08-21.33s-7.67,1.24-11.8,7.19-21.88,27.21-21.88,27.21q-6.33-3.34-12.6-6.78c-3.45-1.88-6.9-3.76-10.28-5.78a12.88,12.88,0,0,1-2.64-1.72c-1.65-1.7-1.27-5.73-1.19-7.92,0-1,.08-2,.22-3.06.17-1.25.48-4.31-1.79-3.39a2.85,2.85,0,0,0-1.1.88,5,5,0,0,0-.84,1.52c-.46,1.32-.35,2.77-.77,4.1a1.12,1.12,0,0,1-.29.52,1,1,0,0,1-.72.2c-3.28-.17-6.28-4.84-7.73-7.31a6.73,6.73,0,0,0-2.43-2.9c-1.77-.88-4,.28-5.15,1.86a10.41,10.41,0,0,0-1.79,7.19,14.42,14.42,0,0,0,4.08,9.17A44.18,44.18,0,0,0,311.51,268.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,238.45c-3.13.29-8.33.41-13.55,6.06-6.1,6.6-14.19,17.43-14.19,17.43a17.38,17.38,0,0,0,13.42,13.21s11-10.75,14.1-16.73S383.68,242.61,380.08,238.45Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.36,351.73c4.07-.2,7.26-3.19,16.94-7.23,17.88-7.45,31.29-13.41,36.4-22.77s8.73-36.4,7.45-48.11a15.74,15.74,0,0,0-.87-3.88l1.25-.19-3.25-2.77h0c-3.35-2.73-8.78-.3-12.88,1.93-11.71,6.37-20.86,12.56-28.1,34.91-5.44,16.81-9,32.15-16.54,40.35",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,269.74l1.25-.19-3.25-2.77h0c-3.35-2.73-8.78-.3-12.88,1.93-11.71,6.37-20.86,12.56-28.1,34.91-5.44,16.81-9,32.15-16.54,40.35l-.4,7.75c4.07-.2,7.26-3.19,16.94-7.23,17.88-7.45,31.29-13.41,36.4-22.77s8.73-36.4,7.45-48.11A15.74,15.74,0,0,0,428.28,269.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.79,271.6c-11.7,6.37-20.86,12.56-28.09,34.91s-11.2,42.1-25.46,45.93c0,0,6.45,2.56,26.21-5.8,6.29-2.65,13.91-7.5,18.93-10.32,9.82-5.51,15.77-10,16.71-11.72,5.2-9.32,8.73-36.39,7.45-48.1S422.66,268.41,416.79,271.6Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,347.53c1,2.71,5.73,2.22,10.81,2.38,4.1.13,8.84-.63,11.44.72s3.13,4.53-1.18,8.13c-5.38,4.49-12.5,4-16.49,4.38s-6.35,1.79-10,1.68c-4.69-.14-7.44-1.75-8.05-3.1s.09-11.38,2-10.89c0,0-.2-.31,6.68-.55C155.13,350.12,155,347.53,155,347.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66,351.43c0-.15-1.15-9.44-1.15-9.44s.19-.81,5.77-1c2.74-.09,5.94-2.38,6.24-.21s.52,6.75.52,6.75c1,2.71,5.73,2.22,10.81,2.38.85,0,1.74,0,2.62,0h.05c2.72.25,5.19,2.26,2,4.15s-7.89,2.09-12.26,2.23C153,356.46,143.83,356.66,143.66,351.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.4,288.12c.42,10.12-1,57.91-1,57.91s-4.82,2.33-12.67-.37l-5.22-51.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.4,288.12c.42,10.12-1,57.91-1,57.91s-4.82,2.33-12.67-.37l-5.22-51.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.93,368.88c.92,2.75,5.66,2.42,10.73,2.75,4.09.27,8.86-.33,11.41,1.11s3,4.64-1.45,8.08c-5.53,4.31-12.63,3.57-16.63,3.83s-6.41,1.57-10,1.34c-4.69-.3-7.38-2-7.95-3.37s.48-11.37,2.41-10.82c0,0-.19-.32,6.7-.32C180.94,371.48,180.93,368.88,180.93,368.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,372.4c0-.15-.83-9.47-.83-9.47s.21-.8,5.8-.8c2.74,0,6-2.18,6.24,0s.29,6.75.29,6.75c.92,2.75,5.66,2.42,10.73,2.75.85.06,1.73.07,2.62.08h.05c2.71.34,5.11,2.44,1.91,4.22s-8,1.82-12.33,1.82C178.64,377.75,169.43,377.63,169.43,372.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,306.06c1.19,10.49.88,47.15,1,58.35a23.42,23.42,0,0,1-12.82.08s-9.09-39.35-8.41-50.56C160.33,308.6,180.2,306.06,180.2,306.06Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.18,424.48a1.21,1.21,0,0,0,1.21-1.21v-77.4a1.21,1.21,0,1,0-2.41,0v77.4A1.21,1.21,0,0,0,115.18,424.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.29,396.3a1.19,1.19,0,0,0,1.12-.76l23.74-60.08a1.2,1.2,0,1,0-2.24-.88L66.17,394.66a1.2,1.2,0,0,0,.68,1.56A1.17,1.17,0,0,0,67.29,396.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.14,389.09a1.22,1.22,0,0,0,.88-.38L115.18,342l44.09,46.54a1.2,1.2,0,1,0,1.75-1.65l-45-47.47a1.22,1.22,0,0,0-.88-.37h0a1.19,1.19,0,0,0-.87.37l-45,47.67a1.21,1.21,0,0,0,.87,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.07,396.3a1.19,1.19,0,0,0,1.12-1.64l-23.73-60.08a1.2,1.2,0,0,0-2.24.88L162,395.54A1.2,1.2,0,0,0,163.07,396.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,319.32c.87-4.85-3.09-8.64-10.53-13.66a175.82,175.82,0,0,0-21.56-12.12C125.33,290.68,119,291,111,295c-11.07,5.69-44.4,25.9-44.4,25.9s49.83,28.13,59.41,26.87,33.55-16.84,35.45-22.33S163.65,319.32,163.65,319.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.19,341.89c7.15,6.48,14.63.9,26.46-6.77,13.38-8.69,16-15.8,16-15.8s0,5.33-1,7.83-3.17,5.32-12.82,12-16.64,10-23.13,11.22l-5.12-.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93,387.23l-3.14,8.28a.76.76,0,0,0,0,.21v.15a1,1,0,0,0,.48.53,2.14,2.14,0,0,0,1.91,0,.9.9,0,0,0,.37-.39v0l0-.11,2.9-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.44,387.23l3.14,8.28a1.49,1.49,0,0,1,0,.21.38.38,0,0,1,0,.15c0,.17-.24.39-.47.53a2.14,2.14,0,0,1-1.91,0,.9.9,0,0,1-.37-.39v0l0-.11-2.91-7.76Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,417.28v6.85a.69.69,0,0,0,.4.57,2.18,2.18,0,0,0,2,0,.68.68,0,0,0,.41-.57v-6.85A3,3,0,0,0,113.8,417.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.82,300.85s42-12.67,49.31-14.67,21.31-5.37,25.4-3.53,6.17,4,6.55,9.86c.08,1.11,0,6.52,0,6.52s-20.31,6.28-36.94,6.28S79.82,300.85,79.82,300.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.82,300.85s42-12.67,49.31-14.67,21.31-5.37,25.4-3.53,6.17,4,6.55,9.86c.08,1.11,0,6.52,0,6.52s-20.31,6.28-36.94,6.28S79.82,300.85,79.82,300.85Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.67,295.59c-2.63,9-3.46,17.79,2.84,24.28,4.58,4.72,12.85,18.86,38,17.79,11.36-.47,43.18-22.68,43.18-22.68s15.51-2.32,15.58-6.54c0-1,1.18-1.28,1-2.38-1.73-9.22-7.5-14.42-15.59-14.91-12.81-.77-47.91,8.37-47.91,8.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.24 223.02 108.07 241.55 93.68 239.33 97.62 218.86 112.24 223.02",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.77,228.58c-6.7-.23-11.34,2.92-14.93,12s-14.65,31-14.93,37.23c-.29,6.46,20.2,26.41,19.46,26.06-.23-.11,6.54-11.77,6.54-11.77L77.74,276.89l6-16.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,228.61a12.12,12.12,0,0,0-11.22,4.3c-4.15,4.88-11.17,22.78-11.17,22.78s3.35,8.75,14.4,8.75L94,243Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83,292.65a102.11,102.11,0,0,1,7.85-15.45c-4.54-19.77-6.53-27.76-5-37,1-6.06,5.14-12.62,11.22-11.57,1.58.27,2.2.25,3.69.53-.84,3.09,9.84,5.59,14.69,2.46,2.18.52,8.76,1.45,8.76,1.45,2.81,1,12.78,16.22,14.47,25.49,1.74,9.57-6.79,15.5-6.79,15.5.43,8,.13,16.55-.06,31.14,0,0-5.2,10-28.35,7.37-20.58-2.3-23.23-11.11-23.23-11.11A70.34,70.34,0,0,1,77.83,292.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.56,240.24a20.55,20.55,0,0,0-5.25,3.76c-.15.13-1.56,1.58-2.23,1.39a.7.7,0,0,1-.43-.47c-.24-.77.93-3.09,1-3.88s-.41-1.84-1.19-1.69a1.43,1.43,0,0,0-.73.46,16.34,16.34,0,0,0-4,7.33,34.08,34.08,0,0,1-1.52,4.88c-1.18,2.56-23,18-23.41,18.3,0,0-13.15-15.64-20.54-25.48-8-10.66-11-10.05-17.29-11.78-4.92,17.37,9.31,30.44,9.31,30.44s11.83,12.16,19.21,17.61c4.74,3.5,7.51,5.8,10,5.8s4.55-1.28,6.58-2.79c4.8-3.58,19.28-18.14,20.87-19.75,2.73-2.76,5.65-5.29,8.31-8.08l8.83-9.25a13.16,13.16,0,0,0,2-2.51,3.88,3.88,0,0,0-3.53-6.06,11,11,0,0,0-5.19,1.37Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.31,232.32s6.94-.07,10.57,2.77c2.76,2.15,21.51,25,21.51,25s.88,8.48-11.74,14L119,257.68S111,245.87,114.31,232.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,206.62s5.24-9.08,1.38-16.24c-4.54-8.43-14.26-11.39-26.21-9.1-5.92,1.14-15.45,6.67-17,17.77-1.18,8.55,22.33,16.63,21.35,22.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.66,206.62s5.24-9.08,1.38-16.24c-4.54-8.43-14.26-11.39-26.21-9.1-5.92,1.14-15.45,6.67-17,17.77-1.18,8.55,22.33,16.63,21.35,22.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,205.77s3.43,6,2.93,6.46-3.25.8-3.25.8Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.93,188.53c3.12,2,8.49,5.74,8.74,18,.26,12.59-1.78,16.78-3.64,18.24-1.26,1-9.5.85-11.75,0-3.79-1.43-11.27-7.16-14.54-14-3.85-8-3.8-18.17,1.91-21.58C105.69,184.41,114.29,186.82,116.93,188.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,191.32c-.11-.42-.25-1.43-.6-1.75A28,28,0,0,0,96,183.88a16.26,16.26,0,0,0-9.23,5.65l.16-3.82a2.72,2.72,0,0,0-2.74,2.56,2.43,2.43,0,0,0,1,2.11H84a14.34,14.34,0,0,0-14.33,14.33V230.3h0A14.33,14.33,0,0,0,84,216l.48-5.41a22,22,0,0,0,2.74,4.74c9.06,11.85,20.82,7.6,20.82,7.6,5.61-2,6.34-8.22,6.34-8.22a5.72,5.72,0,0,1-5.81-1.86c-2.76-2.91-2.6-8,1.36-8.95,2.82-.66,4.66,1.6,5.64,3.86.16.37.37.77.75.88.59.16,1.07-.49,1.32-1.05a34.3,34.3,0,0,0,3.1-11.31A14.89,14.89,0,0,0,120.26,191.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.26,191.32c-.11-.42-.25-1.43-.6-1.75A28,28,0,0,0,96,183.88a16.26,16.26,0,0,0-9.23,5.65l.16-3.82a2.72,2.72,0,0,0-2.74,2.56,2.43,2.43,0,0,0,1,2.11H84a14.34,14.34,0,0,0-14.33,14.33V230.3h0A14.33,14.33,0,0,0,84,216l.48-5.41a22,22,0,0,0,2.74,4.74c9.06,11.85,20.82,7.6,20.82,7.6,5.61-2,6.34-8.22,6.34-8.22a5.72,5.72,0,0,1-5.81-1.86c-2.76-2.91-2.6-8,1.36-8.95,2.82-.66,4.66,1.6,5.64,3.86.16.37.37.77.75.88.59.16,1.07-.49,1.32-1.05a34.3,34.3,0,0,0,3.1-11.31A14.89,14.89,0,0,0,120.26,191.32Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.59,349.64c-4.08-.2-7.26-3.19-17-7.23C86.76,335,73.35,329,68.24,319.64s-8.72-36.4-7.45-48.11a15.27,15.27,0,0,1,.88-3.88l-1.26-.19,3.26-2.77h0c3.34-2.73,8.78-.3,12.87,1.93,11.71,6.37,20.87,12.56,28.1,34.91,5.45,16.81,9,32.15,16.55,40.35",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.15,269.51c11.71,6.37,20.86,12.56,28.1,34.91s11.2,42.1,25.46,45.93c0,0-6.45,2.56-26.21-5.8-6.29-2.65-13.92-7.5-18.93-10.32-9.82-5.51-15.78-10-16.72-11.72-5.19-9.32-8.73-36.39-7.45-48.1S67.29,266.32,73.15,269.51Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,150.06c-2.89,4.05-7.69,5.47-18.78,2.08-3.18-1-7.66-2.6-11.55-4.25-9.21-3.9-13.81-5.44-19.69-8.58-1.25-.67-5.57-6.51-10.27-13.19A17.32,17.32,0,0,0,196,115.5l8.75,12.86c1.51,1.11,12.08,7.69,18.64,10a5,5,0,0,0,3.58-.11c3.06-1.24,5.19-1.11,8.22-1.52,2.37-.32,3.54-1.22,3.86-.71a2.72,2.72,0,0,1-1,3.55,19.56,19.56,0,0,1-4.08,1.95,25.34,25.34,0,0,0,8.06.81C248.16,142,250.66,143.58,246.07,150.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.37,127q-6.25,3.2-12.49,6.42t-12.44,6.43c-3.59,1.88-7.83,3.34-10.6,6.35a18.1,18.1,0,0,0-4.16,5.95,9.71,9.71,0,0,0,.2,6.8,11,11,0,0,0,4.43,5.19,2.93,2.93,0,0,0,2.32.57.85.85,0,0,0,.41-.26,1,1,0,0,0,.15-.56c.11-1.58,0-3.16,0-4.75,0-1.37.15-5.07,2.14-4.76l4.63-1.94c.09-2.13,1.09-1.9,2.81-2.46l3.26-1.06q4.49-1.45,8.94-2.95c3.82-1.28,7.62-2.58,11.4-4,1.93-.71,4.63-1.32,6.25-2.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284,167.31l4.08,5.8a.21.21,0,0,0,.39-.11l.3-7.12Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.41,173v0l.3-7.12-2.52.76.24.84,1.73,5.48Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.42,173a.21.21,0,0,1-.39.11l-.8-1.13h0a1.23,1.23,0,0,0,1.18-.41l.07-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,137.19l.18.63.23.76,8,27.3a3.2,3.2,0,0,1-1.74,1.53,3.23,3.23,0,0,1-3-.1L276,140l-.42-1.45C275.86,139.5,280.62,138.12,280.31,137.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,137.19l.18.63.23.76,8,27.3a3.36,3.36,0,0,1-2.25,1.69l-8.63-28.81c-.09,0-.12,0-.1-.07C279.07,138.37,280.48,137.71,280.31,137.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,139.58l.41,1.41c.13.4-.66.92-1.64,1.3-1.3.51-3,.61-3.14.07l-.31-1-.1-.38c.18.54,1.85.45,3.14-.07.94-.36,1.71-.86,1.64-1.25h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.12,139.94c.3.93-4.47,2.3-4.78,1.37l-.42-1.41c.31.94,5.09-.43,4.78-1.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.31,137.19l.41,1.39c.31.92-4.29,2.28-4.76,1.45,0,0,0,0,0-.05l-.4-1.4C275.86,139.5,280.62,138.12,280.31,137.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.28,173.19a.22.22,0,0,0,.13-.15A.2.2,0,0,1,288.28,173.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.57,131.3l1.74,5.89c.13.4-.65.91-1.62,1.3-1.29.51-3,.62-3.15.09h0l-1.73-5.91c-.35-1.18,2-2.16,3.52-2.09A1.27,1.27,0,0,1,278.57,131.3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,132.71a3.82,3.82,0,0,1-3.39.39.89.89,0,0,1-.51-.63c-.06-1.09,2.08-2,3.56-1.9a1.3,1.3,0,0,1,1.24.7C278.69,131.72,278.37,132.27,277.66,132.71Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.35,154.4c-.06,1.1-.36,2.88-.32,4a4.53,4.53,0,0,0,1.13,3,1.62,1.62,0,0,0,1.83.49,2.11,2.11,0,0,0,.86-1.43,35.42,35.42,0,0,0,1.13-7.87v-.15Z",
    style: {
      fill: "#ffa8a7"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.4dba294984200add8f6a5da35d9209e9.svg";
export { ForwardRef as ReactComponent };